import React from 'react'
import {
    TrainingsOverviewMetaProps,
    AllocationsOverviewMetaProps,
    AdminHubMetaProps,
    AdminSettingsMetaProps,
    AdminTrainingsMetaProps,
    AreaFormModalMetaProps,
    AssignTrainingFormModalMetaProps,
    ConfirmationModalMetaProps,
    DeleteAreaMetaProps,
    DeleteDutyMetaProps,
    DeleteEventMetaProps,
    DeletePreferenceMetaProps,
    DeleteFlagMetaProps,
    DeleteShiftMetaProps,
    DocumentViewerMetaProps,
    DuplicateAreaModalMetaProps,
    DuplicateEventModalMetaProps,
    DutyCardMetaProps,
    DutyFormModalMetaProps,
    DutyMetaProps,
    EventCardMetaProps,
    EventDetailMetaProps,
    EventFormModalMetaProps,
    EventsMetaProps,
    FooterMetaProps,
    HeaderMetaProps,
    HomeMetaProps,
    LoadingSpinnerMetaProps,
    LoginMetaProps,
    Nav,
    PreferenceCardMetaProps,
    PreferenceFormModalMetaProps,
    PreferenceMetaProps,
    FlagCardMetaProps,
    FlagFormModalMetaProps,
    FlagMetaProps,
    FlagCategoryFormModalMetaProps,
    UpdateFlagCategoryFormMetaProps,
    DeleteFlagCategoryMetaProps,
    ShiftFormModalMetaProps,
    DuplicateShiftModalMetaProps,
    CopyShiftAllocationsModalMetaProps,
    CompletionQuestionsModalMetaProps,
    TermsAndConditionsMetaProps,
    TrainingFormModalMetaProps,
    TrainingListMetaProps,
    TrainingModulePageMetaProps,
    UnsupportedModuleViewerMetaProps,
    UpdateAreaFormMetaProps,
    UpdateDutyFormMetaProps,
    UpdateEventFormMetaProps,
    UpdatePreferenceFormMetaProps,
    UpdateFlagFormMetaProps,
    UpdateShiftFormMetaProps,
    UpdateTrainingFormMetaProps,
    VideoPlayerMetaProps,
    VolunteerCardMetaProps,
    VolunteerFormModalMetaProps,
    VolunteerProfileMetaProps,
    VolunteersMetaProps,
    VolunteerTrainingPageDetailsMetaProps,
    VolunteerTrainingPageMetaProps,
    VolunteerPoliciesMetaProps,
    TrainingModuleMetaProps,
    AnnouncementMetaProps,
    AnnouncementFormModalMetaProps,
    AnnouncementViewModalMetaProps,
    BulkTrainingAssignmentFormMetaProps,
    ShiftAssignmentFormMetaProps,
    VolunteerFiltersWithConflictProps,
    UserFormModalMetaProps,
    UpdateUserFormMetaProps,
    DeleteUserMetaProps,
    LeadAssignModalPropsMeta,
    AccessColorMetaProps,
    AccessColorFormModalMetaProps,
    CoreTeamMetaProps,
    CoreTeamStatsMetaProps,
    CoreTeamTableMetaProps,
    RejectedCoreTeamTableMetaProps,
    CoreTeamFormModalMetaProps,
    CoreTeamAddModalMetaProps,
    Role,
    TrainingSequenceEditMetaProps,
    MaxChartSize,
    ManagementAnalyticsMetaProps,
    AnalyticsTab,
    VolunteerOverviewMetaProps,
    DashboardMetaProps,
    InternationalRegisterationsMetaProps,
    CoreStreamOverviewMetaProps,
    VolunteerStatsTableOverviewMetaProps,
    DidarAcknowledgementOverviewMetaProps,
    EmailCampaignsMetaProps,
    EmailCampaignFormMetaProps,
    EmailCampaignPreviewMetaProps,
    ShiftMoveModalMetaProps,
    VolunteerUploadDocumentFormMetaProps,
    AllocationStatusPageMetaProps,
    CheckInPageMetaProps,
    DutyStatusOverviewMetaProps,
    QuickAllocateModalMetaProps,
    LiveOperationsMetaProps,
    LiveStatusTab,
    LoginFormMetaProps,
    ForgetPasswordMetaProps,
    ResetPasswordMetaProps,
    SignupMetaProps,
    VerifyEmailMetaProps,
    HouseholdSelectionMetaProps,
    CheckInLoginFormMetaProps,
    PublicFormFillMetaProps,
    PublicFormsMetaProps,
    GuidelineFormModalMetaProps,
    AdminGuidelinesMetaProps,
    VolunteerGuidelinesMetaProps,
    GuidelineDetailsMetaProps,
    DirectorVolunteerMetaProps
} from './types'
import { Link } from 'react-router-dom'
import { ExternalLinkIcon } from '../icons'

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api'
const IIUK_BASE_URL = process.env.REACT_APP_IIUK_BASE_URL || 'https://iiuk.org'

export const ROLE_MAP: { [key in Role]: string } = {
    volunteer: 'متطوع',
    lead: 'قائد فريق',
    super_lead: 'قائد فريق أول',
    allocating_lead: 'قائد التخصيص',
    reallocation_manager: 'مدير إعادة التخصيص',
    core_team: 'الفريق الأساسي',
    core_team_approver: 'معتمد الفريق الأساسي',
    hr_team_member: 'عضو فريق الموارد البشرية',
    hr_deputy: 'نائب الموارد البشرية',
    hr_admin: 'مدير الموارد البشرية',
    admin: 'مدير النظام',
    checkin_volunteer: 'متطوع تسجيل الحضور',
    checkin_admin: 'مدير تسجيل الحضور',
    lead_with_stats: 'قائد مع إحصائيات',
    jv_exec: 'JV Exec',
    jv_lead: 'JV Lead',
    iv_director: 'IV Director',
    iv_deputy_director: 'IV Deputy Director'
}

const HeaderNav: Nav = {
    home: { title: 'الرئيسية', path: `/` },
    profile: { title: 'الملف الشخصي', path: `/profile` },
    trainings: { title: 'تدريباتي', path: '/volunteer/training' },
    policies: { title: 'السياسات', path: '/volunteer/policies' },
    events: { title: 'الفعاليات', path: '/events', show: (user) => user.permissions?.includes('view_events') && user.permissions.includes('view_admin_hub') },
    check_in: { title: 'تسجيل الحضور', path: '/admin/check-in', show: (user) => user.permissions?.includes('manage_check_ins') },
    coreTeam: { title: 'الفريق الأساسي', path: '/core-team', show: (user) => user.permissions?.includes('view_core_team') },
    admin: { title: 'الإدارة', path: `/admin`, show: (user) => user.permissions?.includes('view_admin_hub') },
    faq: { title: 'الأسئلة الشائعة', path: 'https://iv.iiuk.org/vms-faq/' },
}

export const HeaderMeta: HeaderMetaProps = {
    title: 'نظام إدارة المتطوعين',
    themeToggleLightLabel: 'التبديل إلى الوضع الفاتح',
    themeToggleDarkLabel: 'التبديل إلى الوضع الداكن',
    themeToggleSystemLabel: 'استخدام سمة النظام',
    languageSelectorLabel: 'اختيار اللغة',
    logout: 'تسجيل الخروج',
    loggingOutText: 'جارٍ تسجيل الخروج...',
    nav: HeaderNav
}

export const FooterMeta: FooterMetaProps = {
    nav: {
        termsAndCondition: 'الشروط والأحكام',
        privacyNotice: 'إشعار الخصوصية'
    },
    version: 2026,
    copyRight: 'جميع الحقوق محفوظة'
}

export const TermsAndConditionsMeta: TermsAndConditionsMetaProps = {
    title: 'موافقة بيانات المتطوع وإشعار الخصوصية',
    content: `بالتسجيل، فإنك تقر وتوافق على أن نظام إدارة المتطوعين الإسماعيلي (VMS) سيقوم بجمع واستخدام بياناتك الشخصية لإدارة شؤون التطوع، بما في ذلك مطابقتك مع المهام المناسبة وإدارة تدريباتك.

**ما نقوم بتخزينه**: نحتفظ فقط بالمعلومات المتعلقة بالتطوع والتي قد تشمل الاسم الكامل وعنوان البريد الإلكتروني ورقم الهاتف المحمول والفئة العمرية وتفضيلات المهام والمهارات. في حال وجود فحوصات سوابق (Disclosure & Barring Services)، قد نسجل هذه المعلومات أيضاً.

**مشاركة معلومات الاتصال (لأغراض التطوع)**: لدعم أنشطة التطوع، قد يتم مشاركة معلومات الاتصال الخاصة بك مع قائد(قادة) الفريق المعنيين في لجنتنا أو مع جهات الاتصال في المؤسسة ذات الصلة (عند الضرورة) حتى يتمكنوا من التواصل معك بشأن مهام التطوع والجداول الزمنية والتحديثات والمتطلبات التشغيلية.

**سجلات التدريب والمهام**: تفهم أن أنشطتك التدريبية (مثل إكمال مقاطع الفيديو التعليمية/التدريبية) ومشاركتك/تخصيص مهامك قد يتم تسجيلها وحفظها في ملفك التطوعي لأغراض تشغيلية وسلامة والامتثال.

**حماية البيانات**: سنعالج ونحفظ بياناتك وفقاً للقوانين واللوائح المعمول بها وسنستخدم إجراءات أمنية فنية وتنظيمية مناسبة. سيتم الاحتفاظ بالبيانات فقط طالما كانت ضرورية لإدارة شؤون التطوع والمتطلبات القانونية/التنظيمية.\n\nبقبول هذه الشروط، أؤكد أنني قرأت ما سبق وأوافق عليه وأوافق على معالجة بياناتي لإدارة التطوع كما هو موضح أعلاه.`,
    agreeButton: 'أوافق',
    disagreeButton: 'لا أوافق'
}


export const AdminHubMeta: AdminHubMetaProps = {
    title: 'مركز الإدارة',
    description: 'الوصول إلى جميع أدوات الإدارة وميزات النظام',
    dashboardTitle: 'لوحة المعلومات',
    dashboardDescription: 'نظرة عامة على المستخدمين والمتطوعين',
    eventsTitle: 'الفعاليات',
    eventsDescription: 'إنشاء وإدارة الفعاليات والأقسام والورديات',
    volunteersTitle: 'المتطوعون',
    volunteersDescription: 'إدارة ملفات المتطوعين والتخصيصات',
    trainingsTitle: 'التدريبات',
    trainingsDescription: 'إنشاء وإدارة المحتوى التدريبي والوحدات',
    dutiesTitle: 'المهام',
    dutiesDescription: 'تحديد وإدارة أنواع المهام للورديات',
    preferencesTitle: 'التفضيلات',
    preferencesDescription: 'إدارة تفضيلات المتطوعين وتوفرهم',
    flagsTitle: 'العلامات',
    flagsDescription: 'إدارة علامات وخصائص المتطوعين',
    settingsTitle: 'إعدادات النظام',
    settingsDescription: 'تهيئة إعدادات النظام العامة وتنفيذ الإجراءات الجماعية',
    announcementsTitle: 'الإعلانات',
    announcementsDescription: 'إرسال إعلانات لإبقاء جميع المتطوعين على اطلاع',
    userTitle: 'إدارة المستخدمين',
    userDescription: 'إدارة المستخدمين والأدوار مع التحكم في الوصول',
    accessColorTitle: 'ألوان الوصول',
    accessColorDescription: 'إدارة ألوان الوصول للتحكم في دخول المتطوعين إلى الفعالية.',
    emailCampaignsTitle: 'حملات البريد الإلكتروني',
    emailCampaignsDescription: 'إنشاء وإرسال رسائل بريد إلكتروني جماعية للمتطوعين',
    formsTitle: 'Forms',
    formsDescription: 'Create public forms and review submitted responses',
    miTitle: 'الإحصائيات',
    miDescription: 'رؤى وتحليلات ملخصة',
    internationalRegisterationTitle: 'التسجيلات غير IIUK',
    internationalRegisternationDescription: 'إدارة تسجيلات المتطوعين غير IIUK.',
    allocationStatusTitle: 'قبول المهام',
    allocationStatusDescription: 'عرض وإدارة حالة قبول/رفض مهام المتطوعين',
    checkInTitle: 'تسجيل الحضور',
    checkInDescription: 'مسح الشارات لتسجيل حضور المتطوعين في مهامهم',
    eventDayTitle: 'العمليات الحية للفعالية',
    eventDayDescription: 'مراقبة حضور المتطوعين في الوقت الفعلي وتغطية الورديات والمقاييس التشغيلية الحرجة',
    userLogTitle: "سجل المستخدم",
    userLogDescription: "مراقبة نشاط المستخدم",
    guidelineTitle: "الإرشادات",
    guidelineDescription: "إنشاء وإدارة محتوى الإرشادات",
    JvTitle: "نقاط المتطوعين الصغار",
    JVDescription: "إدارة النقاط التي يكسبها المتطوعون الصغار",
    directorVolunteerTitle: "متطوعو جامات خانتك",
    directorVolunteerDescription: "عرض جميع المتطوعين في جامات خانتك."
}

export const PublicFormsMeta: PublicFormsMetaProps = {
    title: 'Forms',
    description: 'Create public forms and review responses submitted through shared links',
    backButton: 'Back to Admin Hub',
    createButton: 'Create Form',
    errorTitle: 'Something went wrong',
    noFormsMessage: 'No forms have been created yet.',
    publicUrlLabel: 'Public URL',
    copyLinkButton: 'Copy Link',
    copiedText: 'Copied',
    editButton: 'Edit',
    deleteButton: 'Delete',
    viewResultsButton: 'View Results',
    hideResultsButton: 'Hide Results',
    submissionsTitle: 'Responses',
    noSubmissionsMessage: 'No responses have been submitted yet.',
    submittedAtLabel: 'Submitted',
    activeLabel: 'Active',
    inactiveLabel: 'Inactive',
    submissionsCountLabel: 'responses',
    titleLabel: 'Title',
    slugLabel: 'Custom URL',
    overrideUrlLabel: 'Override URL',
    overrideUrlHelpText: 'Optional. Leave this off to generate a random public link automatically. Turn it on to choose a friendly ending for the URL.',
    customUrlPlaceholder: 'volunteer-interest',
    descriptionLabel: 'Description',
    activeFormLabel: 'Make form live and allow submissions',
    fieldsLabel: 'Fields',
    addFieldButton: 'Add Field',
    fieldLabelLabel: 'Field Label',
    fieldTypeLabel: 'Field Type',
    requiredLabel: 'Required',
    optionsLabel: 'Options',
    optionPlaceholder: 'Option text',
    addOptionButton: 'Add Option',
    removeButton: 'Remove',
    saveButton: 'Save Form',
    savingButton: 'Saving...',
    createModalTitle: 'Create Form',
    editModalTitle: 'Edit Form',
    textTypeLabel: 'Single Line Text',
    emailTypeLabel: 'Email Address',
    checkboxTypeLabel: 'Checkbox Group',
    radioTypeLabel: 'Radio Group',
    selectTypeLabel: 'Dropdown Select',
    deleteTitle: 'Delete Form',
    deleteMessage: 'This will permanently delete the form and all submitted responses.',
    matchByLabel: 'Match volunteers by',
    matchedVolunteerColumn: 'Matched Volunteer',
    matchingLabel: 'Matching...',
    noMatchLabel: 'No match',
    selectMatchButton: (count: number) => `Select (${count})`,
    changeMatchButton: 'Change',
    matchModalTitle: 'Select Matched Volunteer',
    matchModalDescription: 'More than one volunteer matched this email address. Select the correct one.',
    matchIdColumn: 'ID',
    matchNameColumn: 'Name',
    matchEmailColumn: 'Email',
    matchSelectButton: 'Select',
    matchCloseButton: 'Close',
    approveAndAllocateButton: 'Approve & Assign',
    allocateModalTitle: 'Approve and Assign Volunteer',
    allocateEventLabel: 'Event',
    allocateAreaLabel: 'Area',
    allocateShiftLabel: 'Shift',
    allocateSelectEventPlaceholder: 'Select an event',
    allocateSelectAreaPlaceholder: 'Select an area',
    allocateNoShiftsMessage: 'No shifts found for this area.',
    approveAndAllocateConfirmButton: 'Approve & Assign',
    approveAndAllocatingButton: 'Approving...',
    approveAndAllocateSuccessMessage: 'Volunteer approved and assigned successfully.',
    allocateCloseButton: 'Close',
    exportLabel: 'Allow Exports',
    exportResultButton: 'Export Submissions',
    showQrCodeButton: 'Show QR Code',
    qrCodeModalTitle: 'Form QR Code',
    qrCodeModalDescription: 'Scan this code or share the link below to open the public form.',
    downloadPngButton: 'Download PNG',
    qrCodeCloseButton: 'Close'
}

export const PublicFormFillMeta: PublicFormFillMetaProps = {
    loadingText: 'Loading form...',
    errorTitle: 'Unable to load form',
    notFoundMessage: 'This form is not available.',
    requiredLabel: 'Required',
    submitButton: 'Submit',
    submittingText: 'Submitting...',
    successTitle: 'Response Submitted',
    successMessage: 'Thank you. Your response has been recorded.',
    selectPlaceholder: 'Select an option'
}

export const AdminSettingsMeta: AdminSettingsMetaProps = {
    title: 'إعدادات النظام',
    description: 'إدارة إعدادات النظام العامة وتنفيذ الإجراءات الإدارية',
    globalSettingsTitle: 'الإعدادات العامة',
    globalSettingsDescription: 'العلامات وخيارات التهيئة على مستوى النظام',
    visitAnnouncedTitle: 'تم الإعلان عن الزيارة',
    visitAnnouncedDescription: 'تبديل حالة الإعلان العام عن الزيارة. يؤثر هذا على المحتوى المرئي للمستخدمين.',
    internationalSignupsEnabledTitle: 'تم تفعيل التسجيل الدولي',
    internationalSignupsEnabledDescription: 'تبديل إمكانية التسجيل للزوار الدوليين. يؤثر هذا على توفر خيارات تسجيل الدخول والتسجيل للزوار الدوليين.',
    showShiftInfoTitle: 'عرض معلومات الوردية',
    showShiftInfoDescription: 'تبديل عرض معلومات تخصيص الوردية/المهمة في الصفحة الرئيسية للمتطوعين.',
    localModeTitle: 'الوضع المحلي',
    localModeDescription: 'تفعيل البحث المحلي عن الباركود أثناء تسجيل الحضور. عند التفعيل، يتم البحث عن الباركود من قاعدة البيانات المحلية بدلاً من واجهة برمجة التطبيقات الخارجية.',
    trainingManagementTitle: 'إدارة التدريب',
    trainingManagementDescription: 'عمليات جماعية لإدارة تدريبات المتطوعين',
    assignMandatoryTitle: 'تخصيص التدريبات الإلزامية',
    assignMandatoryDescription: 'تخصيص تلقائي لجميع التدريبات الإلزامية للمتطوعين الذين لم يجتازوها بعد',
    assignButton: 'تخصيص لجميع المتطوعين',
    assigningText: 'جارٍ التخصيص...',
    profileManagementTitle: 'إدارة الملفات الشخصية',
    profileManagementDescription: 'عمليات جماعية لإدارة ملفات المتطوعين',
    clearProfilesTitle: 'طلب تحديث الملف الشخصي',
    clearProfilesDescription: 'مسح جميع طوابع وقت تقديم الملفات الشخصية لإلزام جميع المتطوعين بمراجعة وإعادة تقديم ملفاتهم',
    clearProfilesButton: 'طلب جميع الملفات الشخصية',
    clearingProfilesText: 'جارٍ المسح...'
}

export const HomeMeta: HomeMetaProps = {
    greeting: (userName: string) => `مرحباً ${userName}،`,
    motd: 'مرحباً بكم في بوابة نظام إدارة المتطوعين الإسماعيلي. تم إنشاء هذه المنصة لدعم متطوعينا من خلال توفير مساحة مشتركة للوصول إلى الموارد التدريبية وتتبع التعلم وتنسيق مسؤوليات التطوع بطريقة مدروسة. نحن نقدر الوقت والاهتمام والالتزام الذي تواصلون تقديمه من خلال خدمتكم (الخدمة).',
    travelInfo: 'إذا كان لديك ترتيبات سفر مسبقة وترغب في التطوع، يرجى تسجيل اهتمامك. التطوع يعتمد على الترتيبات الشخصية ويجب ترتيب جميع متطلبات السفر والإقامة والتأشيرة والأمور ذات الصلة بشكل مستقل.',
    visitAnnouncedProfileTitle: 'التسجيل للتطوع (لقاء أوروبا (برلين))',
    visitAnnouncedProfileMessage: 'يرجى تسجيل اهتمامك بالتطوع في لقاء أوروبا (برلين) القادم.',
    visitAnnouncedCompleteButton: 'إكمال التسجيل',
    profileIncompleteWarningTitle: 'أكمل ملفك الشخصي',
    profileIncompleteWarningMessage: 'يرجى إكمال ملفك الشخصي للوصول إلى جميع الميزات.',
    completeProfileButton: 'إكمال الملف الشخصي',
    policyIncompleteWarningTitle: 'إجراء مطلوب: مراجعة السياسات',
    policyIncompleteWarningMessage: (count: number) => `لديك ${count} سياسة تتطلب مراجعتك وتأكيدك.`,
    reviewPoliciesButton: 'مراجعة السياسات',
    volunteerMessagesTitle: 'رسائل المتطوع',
    priorityLabel: 'أولوية',
    viewButton: 'عرض',
    previousButton: 'السابق',
    nextButton: 'التالي',
    pageLabel: 'صفحة',
    assignedTrainingsTitle: 'التدريبات المخصصة',
    noIncompleteTrainingsMessage: 'تم إكمال جميع التدريبات المخصصة!',
    incompleteTrainingsMessage: (count: number) => `لديك ${count} تدريب غير مكتمل.`,
    viewTrainingsButton: 'عرض تدريباتي',
    assignedShiftsTitle: 'المهام المخصصة',
    noAssignedShiftsMessage: 'لا توجد مهام مخصصة لك حالياً.',
    acceptButton: 'قبول',
    declineButton: 'رفض',
    pendingLabel: 'قيد الانتظار',
    acceptedLabel: 'مقبول',
    declinedLabel: 'مرفوض',
    loadingShiftsText: 'جارٍ تحميل ورديات...',
    shiftTimeLabel: 'وقت الوردية',
    eventLabel: 'الفعالية',
    areaLabel: 'القسم',
    shiftLabel: 'الوردية',
    shiftLeadLabel: 'قائد الفريق',
    declineHelperText: 'اختيار الرفض يخبرنا أنك غير متاح لهذه المهمة. شكراً لمساعدتنا في التخطيط المسبق.',
    dutiesNotYetAssignedMessage: 'سيتم تخصيص المهام في الوقت المناسب. يرجى المراجعة بانتظام للحصول على التحديثات.',
    // Accept/Decline modal
    acceptThankYouMessage: 'شكراً لقبولك الخدمة (سوا).',
    confirmAcceptMessage: 'يرجى تأكيد رغبتك في قبول هذه الخدمة.',
    tknCheckboxLabel: 'أرغب في تقديم هذه المهمة كجزء من TKN. حدد هذا المربع فقط إذا قدمت نية TKN في عام 2008 و/أو 2018.',
    ivTieScarfLabel: 'للخدمة أثناء اللقاء، يجب ارتداء ربطة عنق/وشاح IV. هل لديك واحدة حالياً؟',
    ivTieScarfYes: 'نعم',
    ivTieScarfNo: 'لا',
    confirmButton: 'تأكيد',
    goBackButton: 'رجوع',
    declineModalTitle: 'رفض المهمة',
    declineReasonLabel: 'سبب الرفض',
    declineReasonPlaceholder: 'يرجى اختيار سبب',
    declineDetailsLabel: 'تفاصيل إضافية (اختياري)',
    declineDetailsPlaceholder: 'يرجى تقديم أي معلومات إضافية...',
    declineReasons: [
        'التوقيت غير مناسب (قد يُعرض عليك وردية أخرى حسب التوفر)',
        'لا أرغب في هذه المهمة بالتحديد (قد يُعرض عليك وردية أخرى حسب التوفر)',
        'غير قادر على الالتزام في هذا الوقت (سأتوجه إلى VRC في اليوم المعني)',
        'لأسباب شخصية أخرى لا أرغب في المتابعة'
    ],
    submitDeclineButton: 'إرسال',
    cancelButton: 'إلغاء',
    startTimeLabel: 'وقت البداية',
    endTimeLabel: 'وقت النهاية'
}

export const EventsMeta: EventsMetaProps = {
    title: 'الفعاليات',
    description: 'تصفح وإدارة جميع الفعاليات القادمة',
    errorTitle: 'خطأ في تحميل الفعاليات',
    noEventsMessage: 'لم يتم العثور على فعاليات',
    noFilteredEventsMessage: 'لا توجد فعاليات تطابق عامل التصفية الحالي',
    filterLabel: 'تصفية سريعة',
    filterPlaceholder: 'ابحث عن الفعاليات حسب الاسم...',
    filterPresetsLabel: 'خيارات جاهزة',
    clearFilterButton: 'مسح',
    createButton: 'إنشاء فعالية جديدة'
}
export const VolunteersMeta: VolunteersMetaProps = {
    title: 'المتطوعون',
    description: 'تصفح وإدارة جميع المتطوعين',
    errorTitle: 'خطأ في تحميل المتطوعين',
    noEventsMessage: 'لم يتم العثور على متطوعين',
    createButton: 'إنشاء متطوع جديد'
}
export const DutyMeta: DutyMetaProps = {
    title: 'المهام المتاحة',
    description: 'تصفح وإدارة جميع المهام المتاحة',
    errorTitle: 'خطأ في تحميل المهام',
    noDutyMessage: 'لم يتم العثور على مهام',
    dutySearchPlaceHolder: 'البحث عن مهمة حسب العنوان...',
    createButton: 'إنشاء مهمة جديدة'
}

export const LoadingSpinnerMeta: LoadingSpinnerMetaProps = {
    loadingText: 'جارٍ التحميل...'
}

export const LoginMeta: LoginMetaProps = {
    ukResidentLoginButton: 'تسجيل الدخول عبر IIUK',
    internationalVisitorLoginButton: 'مجتمع المتطوعين (غير مسجل في IIUK)',
    checkInLoginLink: 'تسجيل دخول تسجيل الحضور',
    helpText: () => <>{`للوصول إلى VMS، يرجى تسجيل الدخول باستخدام بيانات اعتماد IIUK الخاصة بك.

إذا لم تكن مسجلاً بعد في IIUK أو لا يمكنك الوصول إلى حسابك، يرجى استخدام خيار "نسيت كلمة المرور" أولاً لاستعادة الوصول إلى IIUK. بمجرد استعادة الوصول إلى IIUK، ستتمكن من تسجيل الدخول إلى VMS.

إذا كنت لا تزال تواجه مشاكل في تسجيل الدخول أو لديك أسئلة، يرجى التواصل معنا عبر`} <a href="mailto:ivc@iiuk.org" className='underline text-primary-600'>ivc@iiuk.org</a>.</>,
    pendingApprovalTitle: 'الحساب قيد الانتظار للموافقة'
}

export const EventCardMeta: EventCardMetaProps = {
    dateLabel: 'التاريخ',
    timeLabel: 'الوقت',
    locationLabel: 'الموقع',
    areasLabel: 'الأقسام',
    addressLabel: 'العنوان',
    areasSingular: 'قسم',
    areasPlural: 'أقسام',
    viewDetailsButton: 'عرض التفاصيل',
    visibleLabel: 'مرئي',
    perAreaLabel: 'لكل قسم',
    shiftsVisibleTooltip: 'الورديات المؤكدة في هذه الفعالية مرئية للمتطوعين (الرؤية مفعلة على مستوى الفعالية)',
    shiftsPerAreaTooltip: 'رؤية الورديات تُتحكم بها على مستوى القسم - تحقق من الأقسام الفردية'
}
export const VolunteerCardMeta: VolunteerCardMetaProps = {
    dateLabel: 'التاريخ',
    timeLabel: 'الوقت',
    locationLabel: 'الموقع',
    areasLabel: 'الأقسام',
    addressLabel: 'العنوان',
    areasSingular: 'قسم',
    areasPlural: 'أقسام',
    viewDetailsButton: 'عرض التفاصيل'
}
export const DutyCardMeta: DutyCardMetaProps = {
    'nameLabel': 'اسم المهمة'
}

export const PreferenceMeta: PreferenceMetaProps = {
    title: 'التفضيلات المتاحة',
    description: 'تصفح وإدارة جميع تفضيلات المتطوعين',
    errorTitle: 'خطأ في تحميل التفضيلات',
    noPreferenceMessage: 'لم يتم العثور على تفضيلات',
    preferenceSearchPlaceHolder: 'البحث عن تفضيل حسب الاسم أو الفئة...',
    createButton: 'إنشاء تفضيل جديد'
}

export const PreferenceCardMeta: PreferenceCardMetaProps = {
    nameLabel: 'اسم التفضيل',
    categoryLabel: 'الفئة',
    descriptionLabel: 'الوصف'
}

export const EventDetailMeta: EventDetailMetaProps = {
    backToEventsButton: 'العودة إلى الفعاليات',
    areasTitle: 'الأقسام',
    noAreasMessage: 'لم يتم العثور على أقسام لهذه الفعالية',
    shiftsTitle: 'الورديات',
    noShiftsMessage: 'لم يتم تخصيص ورديات لهذا القسم',
    loadingText: 'جارٍ التحميل...',
    errorTitle: 'خطأ',
    dateLabel: 'التاريخ',
    timeLabel: 'الوقت',
    startTimeLabel: 'وقت البداية',
    endTimeLabel: 'وقت النهاية',
    capacityLabel: 'السعة',
    volunteersLabel: 'المتطوعون',
    maxVolunteersLabel: 'الحد الأقصى للمتطوعين',
    descriptionLabel: 'الوصف',
    locationLabel: 'الموقع',
    addressLabel: 'العنوان',
    showShiftsButton: 'عرض الورديات',
    hideShiftsButton: 'إخفاء الورديات',
    leadsTitle: "قادة الفعالية",
    leadNameTitle: "اسم القائد",
    deputyLeadNameTitle: "نائب القائد",
    contactTitle: "الاتصال",
    editEventButton: 'تعديل الفعالية',
    copyShiftAllocationsButton: 'Copy allocations',
    exportShiftRegionStatusButton: 'تصدير حالة الوردية',
    exportingShiftRegionStatusButton: 'جارٍ التصدير...',
    exportShiftRegionStatusError: 'فشل تصدير بيانات حالة الوردية',
    selectEmailCampaignsTitle: 'حدد حملات البريد الإلكتروني',
    selectEmailCampaignsDescription: 'اختر حملات البريد الإلكتروني المرسلة التي يجب احتسابها في أعمدة تم إرسال البريد الإلكتروني نعم/لا في هذا التصدير.',
    selectEmailCampaignsCancelButton: 'إلغاء',
    selectEmailCampaignsExportButton: 'تصدير الحملات المحددة',
    selectEmailCampaignsError: 'يرجى تحديد حملة بريد إلكتروني واحدة على الأقل لهذا التصدير.',
    emailCampaignLoadError: 'فشل تحميل حملات البريد الإلكتروني',
    noEmailCampaignsMessage: 'لا توجد حملات بريد إلكتروني متاحة للاختيار.',
    emailCampaignOptionDetails: (status, sentCount, createdAt) => `${status.replace('_', ' ')} • ${sentCount} تم الإرسال • تم الإنشاء ${new Date(createdAt).toLocaleDateString()}`,
    createAreaButton: 'إنشاء قسم جديد',
    addShiftButton: 'إضافة وردية',
    required_volunteer_count_label: 'المتطوعون المطلوبون',
    allocation_count_label: "المتطوعون المخصصون",
    leads_count_label: "مناصب القيادة",
    multi_allocation_count_label: "بتخصيصات متعددة",
    accepted_allocations_label: 'مقبول',
    rejected_allocations_label: 'مرفوض',
    pending_allocations_label: 'قيد الانتظار',
    visibleLabel: 'مرئي',
    visibleViaEventLabel: 'مرئي عبر الفعالية',
    hiddenLabel: 'مخفي',
    shiftsVisibleTooltip: 'الورديات المؤكدة في هذا القسم مرئية للمتطوعين (الرؤية مفعلة على مستوى القسم)',
    shiftsVisibleViaEventTooltip: 'الورديات المؤكدة في هذا القسم مرئية للمتطوعين (عبر رؤية مستوى الفعالية)',
    shiftsHiddenTooltip: 'الورديات في هذا القسم مخفية عن المتطوعين (فعّل الرؤية على مستوى القسم أو الفعالية)'
}

export const EventFormModalMeta: EventFormModalMetaProps = {
    title: 'إنشاء فعالية جديدة',
    nameLabel: 'اسم الفعالية',
    namePlaceholder: 'أدخل اسم الفعالية',
    organizerLabel: 'المنظم',
    organizerPlaceholder: 'أدخل اسم المنظم',
    startDateLabel: 'تاريخ البداية',
    endDateLabel: 'تاريخ النهاية',
    startTimeLabel: 'وقت البداية',
    endTimeLabel: 'وقت النهاية',
    locationLabel: 'الموقع',
    locationPlaceholder: 'أدخل اسم المكان',
    addressLabel: 'العنوان',
    addressPlaceholder: 'أدخل العنوان الكامل',
    cityLabel: 'المدينة',
    cityPlaceholder: 'أدخل المدينة',
    countryLabel: 'الدولة',
    countryPlaceholder: 'أدخل الدولة',
    submitButton: 'إنشاء الفعالية',
    submittingButton: 'جارٍ الإنشاء...',
    cancelButton: 'إلغاء',
    closeButton: 'إغلاق',
    errorMessage: 'فشل إنشاء الفعالية. يرجى المحاولة مرة أخرى.',
    leadNamePlaceholder: 'اسم القائد',
    leadPhoneNumberPlaceHolder: 'رقم هاتف القائد',
    deputyLeadNamePlaceHolder: 'اسم نائب القائد',
    deputyLeadPhoneNumberPlaceHolder: 'رقم هاتف نائب القائد',
    leadNameTitle: 'تفاصيل القائد',
    leadcontactTitle: 'رقم هاتف القائد',
    deputyLeadNameTitle: 'تفاصيل نائب القائد',
    deputyLeadcontactTitle: 'رقم هاتف نائب القائد',
    required_volunteer_count_title: 'عدد المتطوعين المطلوبين',
    require_walkie_talkie_label: 'يتطلب جهاز اتصال لاسلكي',
    shiftsVisibleLabel: 'الورديات مرئية للمتطوعين',
    shiftsVisibleDescription: 'عند التفعيل، ستكون الورديات المؤكدة في هذه الفعالية مرئية للمتطوعين للقبول/الرفض. يجب أيضاً تأكيد (قفل) الورديات لتكون مرئية.',
    includeInDuplicateChecksLabel: 'تضمين في فحوصات التكرار',
    includeInDuplicateChecksDescription: 'عند التفعيل، سيتم احتساب التخصيصات في هذه الفعالية في فحوصات تكرار المتطوعين. عطّل للفعاليات التي لا ينبغي أن تؤثر على عدد التكرارات.',
}

export const DuplicateEventModalMeta: DuplicateEventModalMetaProps = {
    title: 'نسخ الفعالية',
    nameLabel: 'اسم الفعالية',
    namePlaceholder: 'أدخل اسم الفعالية',
    startDateLabel: 'تاريخ البداية',
    endDateLabel: 'تاريخ النهاية',
    startTimeLabel: 'وقت البداية',
    endTimeLabel: 'وقت النهاية',
    submitButton: 'نسخ الفعالية',
    submittingButton: 'جارٍ النسخ...',
    cancelButton: 'إلغاء',
    errorMessage: 'فشل نسخ الفعالية. يرجى المحاولة مرة أخرى.',
    description: 'سيؤدي هذا إلى إنشاء نسخة من الفعالية تشمل جميع الأقسام والورديات، لكنها لا تشمل تخصيصات المتطوعين. يمكنك تغيير الاسم والتواريخ للفعالية الجديدة.'
}

export const VolunteerFormModalMeta: VolunteerFormModalMetaProps = {
    title: 'معلومات المتطوع',
    nameLabel: 'الاسم الأول',
    namePlaceholder: 'أدخل الاسم الأول',
    lastNameLabel: 'اسم العائلة',
    lastNamePlaceholder: 'أدخل اسم العائلة',
    secondLastNameLabel: 'اسم العائلة الثاني',
    secondLastNamePlaceholder: 'أدخل اسم العائلة الثاني (اختياري)',
    genderLabel: 'الجنس',
    dobLabel: 'تاريخ الميلاد',
    contactLabel: 'رقم الهاتف',
    contactPlaceholder: 'أدخل رقم الهاتف',
    countryCodeLabel: 'رمز الدولة',
    EmailLabel: 'البريد الإلكتروني',
    EmailPlaceholder: 'أدخل عنوان البريد الإلكتروني',
    CountryofResidence: 'دولة الإقامة',
    countryOfBirthLabel: 'دولة الميلاد',
    Jamatkhana: 'جماعت خانة',
    FamilyOriginLabel: 'الأصل العائلي',
    serviceLocationLabel: 'موقع الخدمة',
    serviceRecordLabel: 'يرجى إخبارنا إذا كنت ترغب في الخدمة كمتطوع بزي رسمي أو متطوع بدون زي رسمي',
    languagesLabel: 'اللغات',
    supportNeedsLabel: 'احتياجات الدعم الخاصة',
    supportNeedsPlaceholder: 'يرجى إبلاغنا إذا كنت بحاجة إلى أي مساعدة خاصة',
    volunteerStatusLabel: 'حالة المتطوع',
    ismailiLabel: 'إسماعيلي',
    multiFaithFamilyLabel: 'عائلة متعددة الأديان',
    registeredVolunteerLabel: 'متطوع مسجل',
    eligibleForDutyLabel: 'مؤهل للمهمة',
    preferencesLabel: 'التفضيلات',
    flagsLabel: 'تفاصيل إضافية للمتطوع',
    submitButton: 'إرسال',
    submittingButton: 'جارٍ الإرسال...',
    cancelButton: 'إلغاء',
    closeButton: 'إغلاق',
    errorMessage: 'فشل تقديم الملف الشخصي. يرجى المحاولة مرة أخرى.',
    volunteerForVisit: 'هل ترغب في التطوع خلال اللقاء؟',
    availabilityLabel: 'يرجى تحديد كيف ترغب في المساعدة (يمكنك اختيار عدة خيارات):',
    negativeListLabel: "عدم القدرة على أداء المهام",
    registrationNote: () => <>
        يرجى التأكد من التسجيل للقاء أوروبا (برلين) (إذا كنت مؤهلاً) عبر <Link to={`${IIUK_BASE_URL}`} className='font-medium underline inline-block break-inside-avoid' target='_blank'>IIUK <ExternalLinkIcon className='inline w-3.5 h-3.5' /></Link> أو تطبيق Ismaili.<br />
        هذا التسجيل <i>فقط</i> لإدارة التطوع وليس تسجيلاً للقاء أوروبا (برلين).
    </>,
    registrationAckLabel: 'فهمت',
    successMessage: 'تم تقديم ملفك التطوعي بنجاح.',
}

export const DutyFormModalMeta: DutyFormModalMetaProps = {
    title: 'إنشاء مهمة جديدة',
    negativeListMemberLabel: 'تضمين في القائمة السلبية',
    nameLabel: 'الاسم',
    namePlaceholder: 'أدخل اسم المهمة',
    submitButton: 'إنشاء المهمة',
    submittingButton: 'جارٍ الإنشاء...',
    cancelButton: 'إلغاء',
    closeButton: 'إغلاق',
    errorMessage: 'فشل إنشاء المهمة. يرجى المحاولة مرة أخرى.'
}

export const PreferenceFormModalMeta: PreferenceFormModalMetaProps = {
    title: 'إنشاء تفضيل جديد',
    nameLabel: 'الاسم',
    namePlaceholder: 'أدخل اسم التفضيل',
    categoryLabel: 'الفئة',
    categoryPlaceholder: 'أدخل الفئة',
    descriptionLabel: 'الوصف',
    descriptionPlaceholder: 'أدخل الوصف',
    submitButton: 'إنشاء التفضيل',
    submittingButton: 'جارٍ الإنشاء...',
    cancelButton: 'إلغاء',
    closeButton: 'إغلاق',
    errorMessage: 'فشل إنشاء التفضيل. يرجى المحاولة مرة أخرى.'
}

export const DeleteDutyMeta: DeleteDutyMetaProps = {
    deleteButtonText: 'حذف المهمة',
    confirmTitle: 'حذف المهمة',
    confirmMessage: 'هل أنت متأكد أنك تريد حذف هذه المهمة؟ هذا الإجراء لا يمكن التراجع عنه وسيحذف المهمة المحددة.'
}

export const DeletePreferenceMeta: DeletePreferenceMetaProps = {
    deleteButtonText: 'حذف التفضيل',
    confirmTitle: 'حذف التفضيل',
    confirmMessage: 'هل أنت متأكد أنك تريد حذف هذا التفضيل؟ هذا الإجراء لا يمكن التراجع عنه وسيحذف التفضيل المحدد.'
}

export const FlagMeta: FlagMetaProps = {
    title: 'العلامات المتاحة',
    description: 'تصفح وإدارة جميع علامات المتطوعين',
    errorTitle: 'خطأ في تحميل العلامات',
    noFlagMessage: 'لم يتم العثور على علامات',
    flagSearchPlaceHolder: 'البحث عن علامة حسب الاسم...',
    createButton: 'إنشاء علامة جديدة',
    categorySectionTitle: 'فئات العلامات',
    noCategoryMessage: 'لم يتم العثور على فئات',
    createCategoryButton: 'إنشاء فئة جديدة'
}

export const CoreTeamMeta: CoreTeamMetaProps = {
    title: 'الفريق الأساسي',
    description: 'عرض وإدارة أعضاء الفريق الأساسي عبر جميع المسارات',
    createButton: 'إضافة عضو فريق أساسي',
    errorTitle: 'خطأ في تحميل الفريق الأساسي',
    noDataMessage: 'لم يتم العثور على أعضاء فريق أساسي',
    loadingText: 'جارٍ تحميل أعضاء الفريق الأساسي...'
}

export const CoreTeamStatsMeta: CoreTeamStatsMetaProps = {
    statsTitle: 'الإحصائيات',
    showStatsButton: 'عرض الإحصائيات',
    hideStatsButton: 'إخفاء الإحصائيات',
    genderTitle: 'الجنس',
    regionTitle: 'المنطقة',
    familyOriginTitle: 'الأصل العائلي',
    londonLabel: 'لندن',
    notLondonLabel: 'خارج لندن',
    excludedReservedNote: '(الفئة المحجوزة مستثناة)',
    otherLabel: 'أخرى'
}

export const CoreTeamTableMeta: CoreTeamTableMetaProps = {
    idColumn: 'المعرف',
    nameColumn: 'الاسم',
    streamsColumn: 'المسارات',
    roleColumn: 'الدور',
    tierColumn: 'الفئة',
    phoneColumn: 'الهاتف',
    emailColumn: 'البريد الإلكتروني',
    ismailiColumn: 'إسماعيلي',
    familyOriginColumn: 'الأصل العائلي',
    ageBandColumn: 'الفئة العمرية',
    notesColumn: 'ملاحظات',
    duplicationsColumn: 'التكرارات',
    submittedByColumn: 'مقدم من',
    statusColumn: 'حالة الموافقة',
    activityStatusColumn: 'حالة النشاط',
    actionsColumn: 'الإجراءات',
    approvedStatus: 'معتمد',
    pendingStatus: 'مقدم',
    activeStatus: 'نشط',
    onHoldStatus: 'معلق',
    approveButton: 'اعتماد',
    rejectButton: 'رفض',
    yesLabel: 'نعم',
    noLabel: 'لا',
    viewAllocationsButton: (count: number) => `عرض التكرارات (${count})`,
    streamFilterLabel: 'المسار',
    allStreamsLabel: 'جميع المسارات',
    tierFilterLabel: 'الفئة',
    allTiersLabel: 'جميع الفئات',
    statusFilterLabel: 'حالة الموافقة',
    allStatusLabel: 'جميع الحالات',
    activityStatusFilterLabel: 'حالة النشاط',
    allActivityStatusLabel: 'الكل',
    duplicationsFilterLabel: 'التكرارات',
    anyDuplicationsLabel: 'أي',
    hasDuplicationsLabel: 'يوجد تكرارات',
    noDuplicationsLabel: 'لا توجد تكرارات',
    putOnHoldButton: 'تعليق',
    makeActiveButton: 'تفعيل',
    selectedCountLabel: (count: number) => `${count} محدد`,
    clearSelectionLabel: 'مسح التحديد',
    bulkApproveLabel: 'اعتماد',
    bulkApprovingLabel: 'جارٍ الاعتماد...',
    bulkRejectLabel: 'رفض',
    bulkRejectingLabel: 'جارٍ الرفض...',
    bulkUnapproveLabel: 'إلغاء الاعتماد',
    bulkUnapprovingLabel: 'جارٍ إلغاء الاعتماد...',
    bulkDeleteLabel: 'حذف',
    bulkDeletingLabel: 'جارٍ الحذف...',
    bulkPutOnHoldLabel: 'تعليق',
    bulkPuttingOnHoldLabel: 'جارٍ التعليق...',
    bulkMakeActiveLabel: 'تفعيل',
    bulkMakingActiveLabel: 'جارٍ التفعيل...',
    previousPageLabel: 'السابق',
    nextPageLabel: 'التالي',
    pageInfoLabel: (start: number, end: number, total: number) => `عرض ${start}-${end} من ${total}`,
    rowsPerPageLabel: 'صفوف لكل صفحة',
    exportButton: 'تصدير CSV'
}

export const RejectedCoreTeamTableMeta: RejectedCoreTeamTableMetaProps = {
    title: 'إدخالات الفريق الأساسي المرفوضة',
    nameColumn: 'الاسم',
    streamsColumn: 'المسارات',
    roleColumn: 'الدور',
    tierColumn: 'الفئة',
    rejectedByColumn: 'رُفض بواسطة',
    rejectedDateColumn: 'تاريخ الرفض',
    deleteButton: 'حذف',
    deletingButton: 'جارٍ الحذف...',
    noDataMessage: 'لم يتم العثور على إدخالات مرفوضة',
    searchPlaceholder: 'البحث في الإدخالات المرفوضة...',
    clearFiltersButton: 'مسح',
    exportButton: 'تصدير CSV'
}

export const CoreTeamFormModalMeta: CoreTeamFormModalMetaProps = {
    title: 'إضافة عضو فريق أساسي',
    volunteerLabel: 'المتطوع',
    submittedByLabel: 'مقدم من',
    streamsLabel: 'المسارات',
    streamsSelectedLabel: 'المسار المحدد',
    streamsRequiredError: 'يرجى اختيار مسار واحد على الأقل',
    statusLabel: 'حالة النشاط',
    activeStatus: 'نشط',
    onHoldStatus: 'معلق',
    roleLabel: 'الدور',
    rolePlaceholder: 'أدخل الدور (مثلاً ExCo, PMO)',
    roleRequiredError: 'الدور مطلوب',
    tierLabel: 'الفئة',
    tierRequiredError: 'الفئة مطلوبة',
    notesLabel: 'ملاحظات (اختياري)',
    notesPlaceholder: 'أدخل أي ملاحظات إضافية',
    submitButton: 'تقديم للاعتماد',
    submittingButton: 'جارٍ التقديم...',
    cancelButton: 'إلغاء',
    errorMessage: 'فشل إضافة عضو الفريق الأساسي. يرجى المحاولة مرة أخرى.'
}

export const CoreTeamAddModalMeta: CoreTeamAddModalMetaProps = {
    title: 'اختيار متطوع للإضافة',
    nameSearchPlaceholder: 'البحث حسب الاسم...',
    emailSearchPlaceholder: 'البحث حسب البريد الإلكتروني...',
    phoneSearchPlaceholder: 'البحث حسب الهاتف...',
    idSearchPlaceholder: 'البحث حسب المعرف...',
    searchButton: 'بحث',
    clearButton: 'مسح',
    loadingText: 'جارٍ تحميل المتطوعين...',
    pagesLabel: 'صفحات',
    showingLabel: 'عرض',
    volunteersLabel: 'متطوعين',
    noResultsMessage: 'لم يتم العثور على متطوعين مطابقين لبحثك',
    noVolunteersMessage: 'جميع المتطوعين موجودون حالياً في الفريق الأساسي',
    idColumn: 'المعرف',
    nameColumn: 'الاسم',
    phoneColumn: 'الهاتف',
    emailColumn: 'البريد الإلكتروني',
    jamatKhanaColumn: 'جماعت خانة',
    duplicationsColumn: 'التكرارات',
    viewDuplicationsButton: (count: number) => `عرض (${count})`,
    actionColumn: 'الإجراء',
    addButton: 'إضافة',
    closeButton: 'إغلاق',
    errorMessage: 'فشل تحميل المتطوعين. يرجى المحاولة مرة أخرى.',
    duplicationsModalTitle: (firstName: string, lastName: string) => `التكرارات لـ ${firstName} ${lastName}`,
    shiftAllocationsTitle: (count: number) => `تخصيصات الورديات (${count})`,
    excludedAllocationsTitle: (count: number) => `مستثناة من عدد التكرارات (${count})`,
    excludedAllocationsDescription: 'هذه التخصيصات من فعاليات لا تُحتسب في فحوصات التكرار.',
    coreTeamAssignmentsTitle: (count: number) => `تخصيصات الفريق الأساسي (${count})`,
    leadPositionsTitle: (count: number) => `مناصب القائد/نائب القائد (${count})`,
    excludedLeadPositionsTitle: (count: number) => `مناصب القيادة المستثناة (${count})`,
    excludedLeadPositionsDescription: 'هذه المناصب القيادية من فعاليات لا تُحتسب في فحوصات التكرار.',
    positionTypeColumn: 'النوع',
    statusColumn: 'الحالة',
    eventColumn: 'الفعالية',
    areaColumn: 'القسم',
    shiftColumn: 'الوردية',
    dateTimeColumn: 'التاريخ/الوقت',
    noDuplicationsMessage: 'لم يتم العثور على تخصيصات أخرى أو تخصيصات فريق أساسي.',
    closeModalButton: 'إغلاق',
    submittedStatus: 'مقدم',
    approvedStatus: 'معتمد',
    pendingStatus: 'قيد الانتظار',
    acceptedStatus: 'مقبول',
    declinedStatus: 'مرفوض',
    roleColumn: 'الدور',
    streamsColumn: 'المسارات'
}

export const FlagCardMeta: FlagCardMetaProps = {
    nameLabel: 'اسم العلامة',
    descriptionLabel: 'الوصف',
    hiddenFromRegistrationLabel: 'مخفي من التسجيل'
}

export const FlagFormModalMeta: FlagFormModalMetaProps = {
    title: 'إنشاء علامة جديدة',
    nameLabel: 'الاسم',
    categoryLabel: 'الفئة',
    categoryPlaceholder: 'اختر فئة (اختياري)',
    noCategoryOption: 'بدون فئة',
    namePlaceholder: 'أدخل اسم العلامة (مثلاً مدرب إطفاء، كادر طبي)',
    descriptionLabel: 'الوصف',
    descriptionPlaceholder: 'أدخل وصف العلامة',
    hasExpiryLabel: 'لها تاريخ انتهاء',
    hiddenFromRegistrationLabel: 'إخفاء من نموذج التسجيل',
    submitButton: 'إنشاء العلامة',
    submittingButton: 'جارٍ الإنشاء...',
    cancelButton: 'إلغاء',
    closeButton: 'إغلاق',
    errorMessage: 'فشل إنشاء العلامة. يرجى المحاولة مرة أخرى.'
}

export const UpdateFlagFormMeta: UpdateFlagFormMetaProps = {
    title: 'تحديث العلامة',
    submitButton: 'تحديث العلامة',
    submittingButton: 'جارٍ التحديث...'
}

export const DeleteFlagMeta: DeleteFlagMetaProps = {
    deleteButtonText: 'حذف العلامة',
    confirmTitle: 'حذف العلامة',
    confirmMessage: 'هل أنت متأكد أنك تريد حذف هذه العلامة؟ هذا الإجراء لا يمكن التراجع عنه وسيحذف العلامة المحددة.'
}

export const FlagCategoryFormModalMeta: FlagCategoryFormModalMetaProps = {
    title: 'إنشاء فئة جديدة',
    nameLabel: 'اسم الفئة',
    namePlaceholder: 'أدخل اسم الفئة',
    submitButton: 'إنشاء الفئة',
    submittingButton: 'جارٍ الإنشاء...',
    cancelButton: 'إلغاء',
    errorMessage: 'فشل إنشاء الفئة. يرجى المحاولة مرة أخرى.'
}

export const UpdateFlagCategoryFormMeta: UpdateFlagCategoryFormMetaProps = {
    title: 'تحديث الفئة',
    submitButton: 'تحديث الفئة',
    submittingButton: 'جارٍ التحديث...'
}

export const DeleteFlagCategoryMeta: DeleteFlagCategoryMetaProps = {
    deleteButtonText: 'حذف',
    confirmTitle: 'حذف الفئة',
    confirmMessage: 'هل أنت متأكد أنك تريد حذف هذه الفئة؟ لن يتم حذف العلامات الموجودة في هذه الفئة، لكن لن يكون لها فئة مخصصة.'
}

export const ConfirmationModalMeta: ConfirmationModalMetaProps = {
    confirmButton: 'حذف',
    cancelButton: 'إلغاء',
    deletingButton: 'جارٍ الحذف...'
}

export const DeleteEventMeta: DeleteEventMetaProps = {
    deleteButtonText: 'حذف الفعالية',
    confirmTitle: 'حذف الفعالية',
    confirmMessage: 'هل أنت متأكد أنك تريد حذف هذه الفعالية؟ هذا الإجراء لا يمكن التراجع عنه وسيحذف جميع الأقسام والورديات والتخصيصات المرتبطة.',
    detailDeleteButtonText: 'حذف الفعالية'
}

export const UpdateEventFormMeta: UpdateEventFormMetaProps = {
    title: 'تعديل الفعالية',
    submitButton: 'تحديث الفعالية',
    submittingButton: 'جارٍ التحديث...'
}

export const UpdateDutyFormMeta: UpdateDutyFormMetaProps = {
    title: 'تعديل المهمة',
    submitButton: 'تحديث المهمة',
    submittingButton: 'جارٍ التحديث...'
}

export const UpdatePreferenceFormMeta: UpdatePreferenceFormMetaProps = {
    title: 'تعديل التفضيل',
    submitButton: 'تحديث التفضيل',
    submittingButton: 'جارٍ التحديث...'
}

export const AreaFormModalMeta: AreaFormModalMetaProps = {
    title: 'إنشاء قسم جديد',
    nameLabel: 'اسم القسم',
    namePlaceholder: 'أدخل اسم القسم',
    submitButton: 'إنشاء القسم',
    submittingButton: 'جارٍ الإنشاء...',
    cancelButton: 'إلغاء',
    closeButton: 'إغلاق',
    errorMessage: 'فشل إنشاء القسم. يرجى المحاولة مرة أخرى.',
    leadNameTitle: 'اسم القائد',
    leadcontactTitle: 'رقم هاتف القائد',
    deputyLeadNameTitle: 'اسم نائب القائد',
    deputyLeadcontactTitle: 'رقم هاتف نائب القائد',
    leadNamePlaceholder: 'أدخل اسم القائد',
    leadPhoneNumberPlaceHolder: 'أدخل رقم هاتف القائد',
    deputyLeadNamePlaceHolder: 'أدخل اسم نائب القائد',
    deputyLeadPhoneNumberPlaceHolder: 'أدخل رقم هاتف نائب القائد',
    required_volunteer_count_title: 'عدد المتطوعين المطلوبين',
    accessColorLabel: 'لون الوصول',
    require_walkie_talkie_label: 'يتطلب جهاز اتصال لاسلكي',
    shiftsVisibleLabel: 'الورديات مرئية للمتطوعين',
    shiftsVisibleDescription: 'عند التفعيل، ستكون الورديات المؤكدة في هذا القسم مرئية للمتطوعين للقبول/الرفض. يجب أيضاً تأكيد (قفل) الورديات لتكون مرئية.',
}

export const UpdateAreaFormMeta: UpdateAreaFormMetaProps = {
    title: 'تعديل القسم',
    submitButton: 'تحديث القسم',
    submittingButton: 'جارٍ التحديث...'
}

export const DeleteAreaMeta: DeleteAreaMetaProps = {
    deleteButtonText: 'حذف القسم',
    confirmTitle: 'حذف القسم',
    confirmMessage: 'هل أنت متأكد أنك تريد حذف هذا القسم؟ هذا الإجراء لا يمكن التراجع عنه وسيحذف جميع الورديات والتخصيصات المرتبطة.'
}

export const ShiftFormModalMeta: ShiftFormModalMetaProps = {
    title: 'إنشاء وردية جديدة',
    dutyLabel: 'نوع المهمة',
    dutyPlaceholder: 'اختر نوع المهمة',
    startTimeLabel: 'وقت البداية',
    endTimeLabel: 'وقت النهاية',
    submitButton: 'إنشاء الوردية',
    submittingButton: 'جارٍ الإنشاء...',
    cancelButton: 'إلغاء',
    closeButton: 'إغلاق',
    errorMessage: 'فشل إنشاء الوردية. يرجى المحاولة مرة أخرى.',
    leadNameTitle: 'اسم القائد',
    leadcontactTitle: 'رقم هاتف القائد',
    deputyLeadNameTitle: 'اسم نائب القائد',
    deputyLeadcontactTitle: 'رقم هاتف نائب القائد',
    leadNamePlaceholder: 'أدخل اسم القائد',
    leadPhoneNumberPlaceHolder: 'أدخل رقم هاتف القائد',
    deputyLeadNamePlaceHolder: 'أدخل اسم نائب القائد',
    deputyLeadPhoneNumberPlaceHolder: 'أدخل رقم هاتف نائب القائد',
    required_volunteer_count_lable: 'عدد المتطوعين المطلوبين',
    accessColorLabel: 'لون الوصول',
    require_walkie_talkie_label: 'يتطلب جهاز اتصال لاسلكي',
    criteriaLabel: 'المعايير (اختياري)',
    criteriaPlaceHolder: 'أدخل المعايير المحددة أو الملاحظات...',
    titleLabel: 'العنوان',
    titlePlaceHolder: 'أدخل عنوان الوردية...',
    instructionLabel: 'التعليمات (اختياري)',
    instructionPlaceHolder: 'أدخل تعليماتك هنا...'
}

export const UpdateShiftFormMeta: UpdateShiftFormMetaProps = {
    title: 'تعديل الوردية',
    submitButton: 'تحديث الوردية',
    submittingButton: 'جارٍ التحديث...'
}

export const DuplicateShiftModalMeta: DuplicateShiftModalMetaProps = {
    title: 'نسخ الوردية',
    description: 'إنشاء نسخة من هذه الوردية. يمكنك اختيار تضمين تخصيصات المتطوعين، والنسخ في نفس القسم أو في فعالية/قسم مختلف.',
    countLabel: 'عدد النسخ',
    countPlaceholder: 'أدخل العدد (1-50)',
    countValidationError: 'يجب أن يكون العدد بين 1 و 50',
    includeAllocationsLabel: 'تضمين تخصيصات المتطوعين',
    includeAllocationsDescription: 'عند التحديد، سيتم نسخ جميع تخصيصات المتطوعين الحالية في الوردية/الورديات الجديدة.',
    destinationLabel: 'الوجهة',
    sameAreaLabel: 'نفس القسم',
    differentAreaLabel: 'فعالية/قسم مختلف',
    eventLabel: 'الفعالية',
    selectEventPlaceholder: 'اختر فعالية',
    areaLabel: 'القسم',
    selectAreaPlaceholder: 'اختر قسم',
    selectAreaError: 'يرجى اختيار قسم للوردية/الورديات المنسوخة',
    submitButton: 'نسخ',
    submittingButton: 'جارٍ النسخ...',
    cancelButton: 'إلغاء',
    errorMessage: 'فشل نسخ الوردية. يرجى المحاولة مرة أخرى.'
}

export const CopyShiftAllocationsModalMeta: CopyShiftAllocationsModalMetaProps = {
    title: 'Copy Shift Allocations',
    description: 'Copy the volunteers allocated to this shift into another shift. The destination shift times will be used and copied allocations will start as pending.',
    sourceShiftLabel: 'Source shift',
    eventLabel: 'Event',
    selectEventPlaceholder: 'Select an event',
    areaLabel: 'Area',
    selectAreaPlaceholder: 'Select an area',
    shiftLabel: 'Shift',
    selectShiftPlaceholder: 'Select a shift',
    selectShiftError: 'Please select a destination shift',
    noTargetShiftsMessage: 'No other shifts available in this area',
    loadEventsError: 'Failed to load events',
    submitButton: 'Copy Allocations',
    submittingButton: 'Copying...',
    cancelButton: 'Cancel',
    errorMessage: 'Failed to copy shift allocations. Please try again.'
}

export const DuplicateAreaModalMeta: DuplicateAreaModalMetaProps = {
    title: 'نسخ القسم',
    description: 'إنشاء نسخ من هذا القسم وجميع وردياته. يمكنك اختيار تضمين تخصيصات المتطوعين أو استبعادها، والنسخ إلى نفس الفعالية أو فعالية مختلفة.',
    countLabel: 'عدد النسخ',
    countPlaceholder: 'أدخل العدد (1-50)',
    countValidationError: 'يجب أن يكون العدد بين 1 و 50',
    includeAllocationsLabel: 'تضمين تخصيصات المتطوعين',
    includeAllocationsDescription: 'عند التحديد، سيتم نسخ جميع تخصيصات الورديات الحالية في هذا القسم إلى القسم/الأقسام الجديدة.',
    destinationLabel: 'الوجهة',
    sameEventLabel: 'نفس الفعالية',
    differentEventLabel: 'فعالية مختلفة',
    eventLabel: 'الفعالية',
    selectEventPlaceholder: 'اختر فعالية',
    selectEventError: 'يرجى اختيار فعالية للقسم/الأقسام المنسوخة',
    loadEventsError: 'فشل تحميل الفعاليات',
    submitButton: 'نسخ',
    submittingButton: 'جارٍ النسخ...',
    cancelButton: 'إلغاء',
    errorMessage: 'فشل نسخ القسم. يرجى المحاولة مرة أخرى.'
}

export const DeleteShiftMeta: DeleteShiftMetaProps = {
    confirmTitle: 'حذف الوردية',
    confirmMessage: 'هل أنت متأكد أنك تريد حذف هذه الوردية؟ هذا الإجراء لا يمكن التراجع عنه وسيحذف جميع التخصيصات المرتبطة.'
}

export const TrainingListMeta: TrainingListMetaProps = {
    assignedTitle: 'التدريبات المخصصة لي',
    availableTitle: 'التدريبات الأخرى المتاحة',
    errorTitle: 'خطأ في تحميل التدريب',
    noAssignedTrainingsMessage: 'لا توجد تدريبات مخصصة لك حالياً.',
    noAvailableTrainingsMessage: 'لا توجد تدريبات أخرى متاحة.',
    loadingText: 'جارٍ تحميل التدريب...',
    modulesLabel: 'الوحدات',
    durationLabel: 'المدة',
    minutesSuffix: 'دقيقة',
    mandatoryBadge: 'إلزامي'
}

export const AdminTrainingsMeta: AdminTrainingsMetaProps = {
    title: 'إدارة التدريبات',
    description: 'إنشاء وتعديل وإدارة الوحدات التدريبية للمتطوعين',
    errorTitle: 'خطأ في تحميل التدريبات',
    noTrainingsMessage: 'لا توجد تدريبات متاحة. انقر على "إنشاء تدريب جديد" للإضافة.',
    loadingText: 'جارٍ تحميل التدريبات...',
    assignVolunteersMessage: 'تخصيص للمتطوعين'
}

export const TrainingFormModalMeta: TrainingFormModalMetaProps = {
    title: 'إنشاء تدريب جديد',
    nameLabel: 'اسم التدريب',
    namePlaceholder: 'أدخل اسم التدريب',
    descriptionLabel: 'الوصف',
    descriptionPlaceholder: 'أدخل وصف التدريب',
    mandatoryLabel: 'تدريب إلزامي',
    policyLabel: 'سياسة (تظهر فقط في الصفحة الرئيسية إذا كانت غير مكتملة)',
    modulesLabel: 'وحدات التدريب',
    addModuleButton: 'إضافة وحدة',
    removeModuleButton: 'حذف',
    moduleTypeLabel: 'نوع الوحدة',
    moduleTitleLabel: 'عنوان الوحدة',
    moduleTitlePlaceholder: 'أدخل عنوان الوحدة',
    moduleUrlLabel: 'الرابط (URL)',
    moduleUrlPlaceholder: 'https://example.com/resource',
    moduleFileLabel: 'ملف',
    moduleFilePlaceholder: 'لم يتم اختيار ملف',
    moduleFileUploadButton: 'رفع ملف',
    moduleFileUploadingButton: 'جارٍ الرفع...',
    moduleFileRemoveButton: 'حذف الملف',
    moduleContentTypeLabel: 'نوع المحتوى',
    moduleContentTypeUrl: 'رابط (URL)',
    moduleContentTypeFile: 'رفع ملف',
    moduleContentTypeLibrary: 'المكتبة',
    browseLibraryButton: 'تصفح المكتبة',
    libraryBrowserTitle: 'اختر فيديو من المكتبة',
    libraryBrowserSelectButton: 'اختر الفيديو',
    libraryBrowserCancelButton: 'إلغاء',
    libraryBrowserLoadingText: 'جارٍ تحميل مقاطع الفيديو...',
    libraryBrowserErrorText: 'فشل تحميل مقاطع الفيديو. يرجى المحاولة مرة أخرى.',
    libraryBrowserNoVideosText: 'لا توجد مقاطع فيديو في المكتبة بعد.',
    moduleDescriptionLabel: 'الوصف (اختياري)',
    moduleDescriptionPlaceholder: 'أدخل وصف الوحدة',
    moduleDurationLabel: 'المدة (دقائق)',
    moduleDurationPlaceholder: '15',
    moduleOrderPlaceholder: '0',
    moduleRequiredLabel: 'مطلوب',
    noModulesMessage: 'لم يتم إضافة وحدات بعد. انقر على "إضافة وحدة" لإنشاء الوحدة الأولى.',
    submitButton: 'إنشاء التدريب',
    submittingButton: 'جارٍ الإنشاء...',
    cancelButton: 'إلغاء',
    closeButton: 'إغلاق',
    errorMessage: 'فشل إنشاء التدريب. يرجى المحاولة مرة أخرى.',
    questionsLabel: 'أسئلة التدريب',
    addQuestionButton: 'إضافة سؤال',
    noQuestionMessage: 'لم يتم إضافة أسئلة بعد. انقر على "إضافة سؤال" لإنشاء السؤال الأول.',
    questionLable: 'السؤال',
    questionPlaceHolder: 'أدخل السؤال هنا',
    answerDescriptionLabel: 'وصف الإجابة (اختياري)',
    answerDescriptionPlaceholder: 'قدم سياقاً أو شرحاً إضافياً لهذا السؤال',
    optionLabel: 'الخيار',
    addOptionButton: 'إضافة خيار',
    noOptionMessage: 'لم يتم إضافة خيارات بعد. انقر على "إضافة خيار" لإنشاء الخيار الأول.',
    optionPlaceHolder: 'أدخل الخيار هنا',
    optionsLabel: 'الخيارات',
    optionSelectionMessage: 'يرجى اختيار الخيار الذي يمثل الإجابة الصحيحة.',
    noOptionsDisplayMessage: 'لا توجد خيارات متاحة لهذا السؤال.'
}

export const UpdateTrainingFormMeta: UpdateTrainingFormMetaProps = {
    title: 'تعديل التدريب',
    submitButton: 'تحديث التدريب',
    submittingButton: 'جارٍ التحديث...'
}

export const DocumentViewerMeta: DocumentViewerMetaProps = {
    loadingText: 'جارٍ تحميل المستند...',
    errorTitle: 'خطأ في تحميل المستند',
    errorInvalidUrl: 'رابط المستند المقدم غير صالح.',
    errorLoadingDocument: 'فشل تحميل المستند. يرجى المحاولة مرة أخرى.'
}

export const VideoPlayerMeta: VideoPlayerMetaProps = {
    loadingText: 'جارٍ تحميل الفيديو...',
    errorTitle: 'خطأ في تحميل الفيديو',
    errorInvalidUrl: 'رابط الفيديو المقدم غير صالح.',
    errorLoadingVideo: 'فشل تحميل الفيديو. يرجى المحاولة مرة أخرى.',
    muteLabel: 'كتم الصوت',
    unmuteLabel: 'إلغاء كتم الصوت',
    enterFullscreenLabel: 'ملء الشاشة',
    exitFullscreenLabel: 'الخروج من ملء الشاشة',
    playbackSpeedLabel: 'السرعة',
    captionsLabel: 'الترجمات'
}

export const UnsupportedModuleViewerMeta: UnsupportedModuleViewerMetaProps = {
    title: 'نوع الوحدة غير مدعوم',
    message: 'عرض وحدات {type} غير مدعوم حالياً.',
    supportedTypes: 'مدعوم حالياً: مستند (PDF)، فيديو (YouTube، Vimeo وغيرها)'
}

export const TrainingModulePageMeta: TrainingModulePageMetaProps = {
    backButtonLabel: 'العودة إلى تفاصيل التدريب',
    moduleLabel: 'الوحدة {current} من {total}',
    previousModuleButton: 'الوحدة السابقة',
    nextModuleButton: 'الوحدة التالية',
    errorTitle: 'خطأ في تحميل الوحدة',
    errorInvalidParameters: 'معلمات التدريب أو الوحدة غير صالحة.',
    errorTrainingNotFound: 'لم يتم العثور على التدريب.',
    errorModuleNotFound: 'لم يتم العثور على الوحدة في هذا التدريب.',
    errorInvalidContent: 'تنسيق محتوى التدريب غير صالح.',
    errorFileNotFound: 'لم يتم العثور على ملف المستند.',
    errorNoDocumentSource: 'لم يتم تحديد رابط مستند أو ملف لهذه الوحدة.',
    errorNoVideoSource: 'لم يتم تحديد رابط فيديو أو ملف لهذه الوحدة.',
    errorGeneric: 'حدث خطأ أثناء تحميل الوحدة.',
    documentViewer: DocumentViewerMeta,
    videoViewer: VideoPlayerMeta,
    unsupportedViewer: UnsupportedModuleViewerMeta
}

export const TrainingModuleMeta: TrainingModuleMetaProps = {
    minutesSuffix: 'دقيقة'
}

export const VolunteerTrainingPageMeta: VolunteerTrainingPageMetaProps = {
    title: "التدريبات المخصصة لك",
    description: "الوصول إلى الوحدات التدريبية المخصصة وإكمالها",
    errorTitle: "خطأ",
    noTrainingMessage: "لم يتم تخصيص أي تدريب لك بعد.",
    viewButton: "عرض التدريب",
}

export const VolunteerPoliciesMeta: VolunteerPoliciesMetaProps = {
    title: "السياسات",
    description: "مراجعة وتأكيد السياسات المطلوبة",
    errorTitle: "خطأ",
    noPoliciesMessage: "لم يتم تخصيص أي سياسات لك بعد.",
    outstandingTitle: "السياسات المعلقة",
    acknowledgedTitle: "السياسات المؤكدة",
    viewButton: "عرض السياسة",
}

export const VolunteerTrainingPageDetailsMeta: VolunteerTrainingPageDetailsMetaProps = {
    backToTrainingsButton: 'العودة إلى التدريبات',
    loadingText: 'جارٍ تحميل التدريب',
    errorTitle: 'خطأ أثناء تحميل تفاصيل التدريب.',
    modulesLabel: 'الوحدات',
    totalDurationLabel: 'المدة الإجمالية',
    minutesSuffix: 'دقيقة',
    mandatoryBadge: 'إلزامي',
    completedBadge: 'مكتمل',
    inProgressBadge: 'قيد التنفيذ',
    moduleNumberPrefix: 'الوحدة',
    completeTrainingButton: 'وضع علامة مكتمل',
    trainingCompletedMessage: 'تم إكمال هذا التدريب بنجاح.',
}

export const ModuleCompletionModalMeta: CompletionQuestionsModalMetaProps = {
    title: "أسئلة الوحدة",
    submitButton: "إرسال الإجابات",
    submittingButton: "جارٍ إكمال الوحدة",
    cancelButton: "إلغاء"
}

export const ProfileMeta: VolunteerProfileMetaProps = {
    loadingText: 'جارٍ التحميل...',
    errorTitle: 'خطأ',
    backToVolunteersButton: 'العودة إلى المتطوعين',
    editProfileButton: 'تعديل الملف الشخصي',
    completeProfileButton: 'إكمال الملف الشخصي',
    noAreasMessage: '',
    csid: 'معرف المتطوع',
    first_name: 'الاسم الأول',
    last_name: 'اسم العائلة',
    second_last_name: 'اسم العائلة الثاني',
    gender: 'الجنس',
    dob: 'تاريخ الميلاد',
    age: 'العمر',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    country_code: 'رمز الدولة',
    country: 'الدولة',
    country_of_birth: 'دولة الميلاد',
    jamat_khana: 'جماعت خانة',
    service_location: 'موقع الخدمة',
    service_record: 'منصب IV',
    family_origin: 'الأصل العائلي',
    languages: 'اللغات',
    support_needs: 'احتياجات الدعم الخاصة',
    multi_faith_family: 'عائلة متعددة الأديان',
    ismaili: 'إسماعيلي',
    registered_volunteer_label: 'متطوع مسجل',
    eligible_for_duty_label: 'مؤهل للمهمة',
    yes: 'نعم',
    no: 'لا',
    personalInfoSection: 'المعلومات الشخصية',
    locationSection: 'معلومات الموقع',
    additionalInfoSection: 'معلومات المتطوع',
    preferencesSection: 'التفضيلات',
    flagsSection: 'معلومات إضافية',
    trainingsSection: 'التدريبات المخصصة',
    deleteTrainingMessage: 'هل أنت متأكد؟ سيتم إزالة هذا التدريب من المتطوع وسيتم فقدان جميع التقدم المرتبط به.',
    deleteTrainingTitle: 'حذف تخصيص التدريب',
    languageSection: 'اللغات',
    volunteer_for_visit_label: 'يرغب في التطوع خلال اللقاء؟',
    availability_label: 'التوفر',
    uploadedDocumentsLabel: "المستندات المرفوعة",
    allocatedShiftsLabel: "التخصيصات",
    eventLeadLabel: "قائد الفعالية",
    areaLeadLabel: "قائد القسم",
    shiftLeadLabel: "قائد الوردية",
    otherAllocationLabel: "أخرى",
    negativeListLabel: "عدم القدرة على أداء المهام"
}

export const VolunteerTableMeta = {
    columns: [
        { key: "csid", header: "المعرف (VID)" },
        { key: "first_name", header: "الاسم الأول" },
        { key: "last_name", header: "اسم العائلة" },
        { key: "email", header: "البريد الإلكتروني" },
        { key: "phone", header: "رقم الهاتف" },
        { key: "gender", header: "الجنس" },
        //{ key: "dob", header: "DOB" },
        { key: "age", header: "العمر" },
        { key: "country_of_birth", header: "دولة الميلاد" },
        { key: "family_origin", header: "الأصل العائلي" },
        { key: "jamat_khana", header: "جماعت خانة" },
        { key: "service_record", header: "منصب IV" },
        { key: "ismaili", header: "إسماعيلي" },
        { key: "multi_faith_family", header: "عائلة متعددة الأديان" },
        { key: "eligible_for_duty", header: "مؤهل للمهمة" },
        { key: "languages", header: "اللغات" },
        { key: "preferences", header: "التفضيلات" },
        { key: "flags", header: "مهارات إضافية" },
        //{ key: "support_needs", header: "Special Support" },
    ],
};


export const VolunteerTrainingTableMeta = {
    columns: [
        { key: "csid", header: "المعرف (VID)" },
        { key: "first_name", header: "الاسم الأول" },
        { key: "last_name", header: "اسم العائلة" },
        { key: "gender", header: "الجنس" },
        //{ key: "dob", header: "DOB" },
        // { key: "age", header: "Age" },
        { key: "service_record", header: "منصب IV" },
        { key: "preferences", header: "التفضيلات" },
        { key: "flags", header: "مهارات إضافية" },
    ],
};

export const VolunteerAllocationTableMeta = {
    columns: [
        { key: "first_name", header: "الاسم الأول" },
        { key: "last_name", header: "اسم العائلة" },
        // { key: "gender", header: "Gender" },
        { key: "jamat_khana", header: "جماعت خانة" },
        { key: "family_origin", header: "الأصل العائلي" },
        { key: "service_record", header: "منصب IV" },
        { key: "flags", header: "مهارات إضافية" },
    ],
};

export const ConflictInformationTableMeta = {
    columns: [
        { key: "event_name", header: "الفعالية" },
        { key: "area_name", header: "القسم" },
        { key: "shift_title", header: "الوردية" },
        { key: "shift_duty_name", header: "المهمة" },
        { key: "start_time", header: "بداية الوردية" },
        { key: "end_time", header: "نهاية الوردية" },
        { key: "type", header: "السبب" },
        { key: "action", header: "الإجراءات" },
    ],
};

export const VolunteerAllocationViewTableMeta = {
    columns: [
        { key: "first_name", header: "الاسم الأول" },
        { key: "last_name", header: "اسم العائلة" },
        { key: "phone", header: "رقم الهاتف" },
        { key: "age_band", header: "الفئة العمرية" },
        { key: "jamat_khana", header: "جماعت خانة" },
        { key: "family_origin", header: "الأصل العائلي" },
        { key: "service_record", header: "منصب IV" },
        { key: "flags", header: "مهارات إضافية" },
        { key: "support_needs", header: "احتياجات الدعم" },
        { key: "action", header: "الإجراءات" },
    ],
};

export const VolunteerEventShiftViewTableMeta = {
    columns: [
        { key: "event_name", header: "الفعالية" },
        { key: "area_name", header: "القسم" },
        { key: "shift_duty_name", header: "الوردية" },
        { key: "start_time", header: "بداية الوردية" },
        { key: "end_time", header: "نهاية الوردية" },
        { key: "status", header: "الحالة" },
        { key: "action", header: "الإجراء" }
    ],
};

export const VolunteerAreaShiftViewTableMeta = {
    columns: [
        { key: "shift_duty_name", header: "الوردية" },
        { key: "start_time", header: "بداية الوردية" },
        { key: "end_time", header: "نهاية الوردية" },
        { key: "status", header: "الحالة" },
        { key: "action", header: "الإجراء" }
    ],
};


export const LeadAssginmentViewTableMeta = {
    columns: [
        { key: "first_name", header: "الاسم الأول" },
        { key: "last_name", header: "اسم العائلة" },
        { key: "email", header: "البريد الإلكتروني" },
        { key: "phone", header: "رقم الهاتف" },
        { key: "flags", header: "مهارات إضافية" },
    ],
};

export const MIVolunteerViewMeta = {
    columns: [
        { key: "first_name", header: "الاسم الأول" },
        { key: "last_name", header: "اسم العائلة" },
        { key: "email", header: "البريد الإلكتروني" },
        { key: "phone", header: "رقم الهاتف" },
        { key: "jamat_khana", header: "جماعت خانة" },
        { key: "family_origin", header: "الأصل العائلي" },
        { key: "service_record", header: "منصب IV" },
        { key: "uk_didar_registration_ack", header: "تأكيد اللقاء" }

    ],
};



export const AssignTrainingFormModalMeta: AssignTrainingFormModalMetaProps = {
    title: "تخصيص تدريب للمتطوع",
    submitButton: "تخصيص",
    submittingButton: "جارٍ التخصيص",
    cancelButton: "إلغاء",
    trainingLabel: "التدريبات المتاحة",
    trainingPlaceHolder: "اختر التدريب",
    addTrainingButton: "إضافة تدريب",
    noTrainingMessage: 'لم يتم إضافة تدريبات بعد. انقر على "إضافة تدريب" لإضافة التدريب الأول.',
    noTrainingSelectedMessage: 'أضف تدريباً واحداً على الأقل للتخصيص.'
}

export const AnnouncementMeta: AnnouncementMetaProps = {
    title: 'الإعلانات',
    description: 'إدارة جميع الإعلانات المرسلة للمتطوعين.',
    createButton: 'منشور جديد',
    submitButton: 'إرسال',
    submittingButton: 'جارٍ الإرسال...',
    errorTitle: 'فشل جلب الإعلانات',
    noAnnouncementsMessage: 'لم يتم نشر أي إعلانات بعد.',
    announcementSearchPlaceHolder: 'البحث عن إعلان حسب العنوان...',
    backButton: 'العودة إلى مركز الإدارة',
    onDeleteTitle: 'حذف الإعلان',
    onDeleteMessage: 'حذف هذا الإعلان سيزيله نهائياً لجميع المستخدمين. هذا الإجراء لا يمكن التراجع عنه.'
}

export const AnnouncementsFormModalMeta: AnnouncementFormModalMetaProps = {
    errorMessage: 'حدث خطأ أثناء تقديم النموذج',
    createTitle: 'نشر إعلان جديد',
    editTitle: 'تفاصيل الإعلان',
    cancelButton: 'إلغاء',
    submitButton: 'إرسال',
    submittingButton: 'جارٍ الإرسال...',
    titleLabel: 'العنوان',
    titlePlaceHolder: 'أدخل عنوان الإعلان...',
    contentLabel: 'المحتوى',
    contentPlaceHolder: 'أدخل محتوى الإعلان...',
    prioritiyMessage: 'وضع علامة كأولوية'
}

export const AnnouncementViewModalMeta: AnnouncementViewModalMetaProps = {
    viewTitle: 'الإعلان',
    titleLabel: 'العنوان',
    contentLabel: 'المحتوى',
    prioritiyMessage: 'هذا إعلان ذو أولوية.',
    cancelButton: 'إغلاق'
}

export const BulkTrainingAssignmentFormMeta: BulkTrainingAssignmentFormMetaProps = {
    title: 'تخصيص ',
    cancelButton: 'إلغاء',
    submitButton: 'تخصيص التدريب',
    submittingButton: 'جارٍ التخصيص...',
    previewButton: 'معاينة',
    previewingButton: 'جارٍ التحميل...',
    // Assignment mode selection
    assignmentModeLabel: 'طريقة التخصيص',
    modeAllVolunteers: 'جميع المتطوعين المسجلين',
    modeAllVolunteersDescription: 'تخصيص لجميع المتطوعين المعتمدين في النظام',
    modeByEvent: 'حسب الفعالية',
    modeByEventDescription: 'تخصيص للمتطوعين المخصصين لفعاليات محددة',
    modeByArea: 'حسب القسم',
    modeByAreaDescription: 'تخصيص للمتطوعين المخصصين لأقسام محددة',
    modeByShift: 'حسب الوردية',
    modeByShiftDescription: 'تخصيص للمتطوعين المخصصين لورديات محددة',
    modeByDuty: 'حسب نوع المهمة',
    modeByDutyDescription: 'تخصيص للمتطوعين المخصصين لورديات بأنواع مهام محددة',
    modeManual: 'اختيار يدوي',
    modeManualDescription: 'تصفية واختيار المتطوعين بشكل فردي يدوياً',
    // Selection labels
    selectEventsLabel: 'اختيار الفعاليات',
    selectAreasLabel: 'اختيار الأقسام',
    selectShiftsLabel: 'اختيار الورديات',
    selectDutiesLabel: 'اختيار أنواع المهام',
    // Lead inclusion options
    includeLeadsLabel: 'تضمين القادة',
    includeEventLeadsLabel: 'تضمين قادة الفعاليات',
    includeAreaLeadsLabel: 'تضمين قادة الأقسام',
    includeShiftLeadsLabel: 'تضمين قادة الورديات',
    // Preview results
    previewResultsTitle: 'معاينة',
    totalVolunteersLabel: 'إجمالي المتطوعين المطابقين للمعايير',
    alreadyAssignedLabel: 'لديهم هذا التدريب بالفعل',
    willBeAssignedLabel: 'سيتم تخصيصهم',
    // Messages
    noSelectionMessage: 'يرجى اختيار عنصر واحد على الأقل',
    selectEventFirst: 'اختر فعالية أولاً لرؤية الأقسام',
    selectAreaFirst: 'اختر قسماً أولاً لرؤية الورديات'
}

export const ShiftAssignmentFormMeta: ShiftAssignmentFormMetaProps = {
    title: 'تخصيص المتطوعين',
    cancelButton: 'إلغاء',
    submitAllocateButton: 'تخصيص',
    submittingAllocateButton: 'جارٍ التخصيص...',
    submitRemoveButton: 'حذف',
    submittingRemoveButton: 'جارٍ الحذف...',
    conflictTitle: 'ورديات متعارضة',
    conflictMessage: 'الورديات التالية تتعارض مع هذا التخصيص.',
    futureConflictMessage: 'الورديات التالية ستتعارض مع هذا التخصيص.',
    duplicationsModalTitle: (firstName: string, lastName: string) => `التكرارات لـ ${firstName} ${lastName}`,
    shiftAllocationsTitle: (count: number) => `تخصيصات الورديات (${count})`,
    excludedAllocationsTitle: (count: number) => `مستثناة من عدد التكرارات (${count})`,
    excludedAllocationsDescription: 'هذه التخصيصات من فعاليات لا تُحتسب في فحوصات التكرار.',
    coreTeamAssignmentsTitle: (count: number) => `تخصيصات الفريق الأساسي (${count})`,
    leadPositionsTitle: (count: number) => `مناصب القائد/نائب القائد (${count})`,
    excludedLeadPositionsTitle: (count: number) => `مناصب القيادة المستثناة (${count})`,
    excludedLeadPositionsDescription: 'هذه المناصب القيادية من فعاليات لا تُحتسب في فحوصات التكرار.',
    positionTypeColumn: 'النوع',
    statusColumn: 'الحالة',
    eventColumn: 'الفعالية',
    areaColumn: 'القسم',
    shiftColumn: 'الوردية',
    actionsColumn: 'الإجراءات',
    dateTimeColumn: 'التاريخ/الوقت',
    noDuplicationsMessage: 'لم يتم العثور على تخصيصات أخرى أو تخصيصات فريق أساسي.',
    closeModalButton: 'إغلاق',
    submittedStatus: 'مقدم',
    approvedStatus: 'معتمد',
    pendingStatus: 'قيد الانتظار',
    acceptedStatus: 'مقبول',
    declinedStatus: 'مرفوض',
    roleColumn: 'الدور',
    streamsColumn: 'المسارات',
    publishShiftTitle: 'إرسال الوردية للاعتماد؟',
    publishShiftMessage: 'بمجرد إرسال هذه الوردية، لا يمكن إجراء أو حذف أي تخصيصات أخرى.',
    publishButton: 'إرسال للاعتماد',
    lockButton: 'قفل',
    unlockButton: 'فتح القفل'
}

export const AllLanguages = [
    "Arabic",
    "Persian / Farsi",
    "Bengali",
    "English",
    "Gujarati / Kutchi",
    "Urdu / Hindi",
    "Punjabi / Sindhi",
    "French",
    "German",
    "Mandarin Chinese / Japanese",
    "Portuguese",
    "Russian",
    "Spanish",
    "Swahili",
    "Turkish",
    "Tajik",

    "Danish",
    "Swedish",
    "Norwegian",
    "Finish",
    "Dutch",
    "Polish",
    "Italian",
]

export const IVPositions = [
    "Non-Uniformed Volunteer",
    "Uniformed Volunteer"
]

export const IVPositionFilterOptions = [
    "Non-Uniformed Volunteer",
    "Uniformed Volunteer",
    "Volunteer",
    "Junior Volunteer",
    "Team Leader",
    "JV Team Leader",
    "Deputy JV Team Leader",
    "Director",
    "Deputy Director",
    "IV Executive",
    "IV Events",
    "Other"
]

export const GenderOptions = [
    "Male",
    "Female",
    "Prefer Not to Say"
]

export const UserMetaProps = {
    title: 'إدارة المستخدمين',
    description: 'إدارة المستخدمين والأدوار مع التحكم في الوصول',
    errorTitle: 'خطأ في تحميل المستخدمين',
}
export const UserFormModalMeta: UserFormModalMetaProps = {
    title: 'إنشاء مستخدم جديد',
    nameLabel: 'الاسم الكامل',
    namePlaceholder: 'أدخل الاسم الكامل',
    emailLabel: 'البريد الإلكتروني',
    emailPlaceholder: 'أدخل عنوان البريد الإلكتروني',
    roleLabel: 'الدور',
    rolePlaceholder: 'اختر الدور',
    submitButton: 'إنشاء المستخدم',
    submittingButton: 'جارٍ الإنشاء...',
    cancelButton: 'إلغاء',
    closeButton: 'إغلاق',
    errorMessage: 'فشل إنشاء المستخدم. يرجى المحاولة مرة أخرى.',
    usernameLabel: 'اسم المستخدم',
    usernamePlaceholder: 'اسم المستخدم',
}

export const UpdateUserFormMeta: UpdateUserFormMetaProps = {
    title: 'تعديل المستخدم',
    submitButton: 'تحديث المستخدم',
    submittingButton: 'جارٍ التحديث...'
}
export const DeleteUserMeta: DeleteUserMetaProps = {
    deleteButtonText: 'حذف المستخدم',
    confirmTitle: 'حذف المستخدم',
    confirmMessage: 'هل أنت متأكد أنك تريد حذف هذا المستخدم؟ هذا الإجراء لا يمكن التراجع عنه وسيحذف المستخدم المحدد.'
}
export const DEFAULT_FILTERS: VolunteerFiltersWithConflictProps = {
    name: "",
    email: "",
    phone_number: "",
    id: "",
    country: "eu",
    age: null,
    country_of_birth: "",
    family_origin: "",
    jamat_khana: "",
    iv_position: "",
    ismaili: null,
    registered_volunteer: null,
    profile_submitted: true,
    approved_volunteer: null,
    eligible_for_duty: true,
    multi_faith_family: null,
    has_support_needs: null,
    tags: [],
    preferences: [],
    languages: [],
    service_record: [],
    genders: [],
    trainings: [],
    training_filter_type: 'at_least_one',
    age_start: 18,
    age_end: null,
    conflict: null,
    status: null,
    volunteer_for_visit: 1,
    iiuk_registeration: "any",
    availability: [],
    availability_filter_type: 'at_least_one',
    event_assignment_type: null,
    event_assignment_events: [],
    documents: [],
    allocation_status: [],
    core_team_assignment_type: null,
    clusters: []
};

export const LeadAssignModalMeta: LeadAssignModalPropsMeta = {
    cancelButton: "إلغاء",
    selectButton: "اختيار",
    nameSearchPlaceholder: 'البحث حسب الاسم...',
    emailSearchPlaceholder: 'البحث حسب البريد الإلكتروني...',
    phoneSearchPlaceholder: 'البحث حسب الهاتف...',
    idSearchPlaceholder: 'البحث حسب المعرف...',
    searchButton: 'بحث',
    clearButton: 'مسح',
    showingLabel: 'عرض',
    volunteersLabel: 'متطوعين',
    noResultsMessage: 'لم يتم العثور على متطوعين مطابقين لبحثك',
    noVolunteersMessage: 'لا يوجد متطوعون متاحون',
    idColumn: 'المعرف',
    nameColumn: 'الاسم',
    phoneColumn: 'الهاتف',
    emailColumn: 'البريد الإلكتروني',
    jamatKhanaColumn: 'جماعت خانة',
    duplicationsColumn: 'التكرارات',
    viewDuplicationsButton: (count: number) => `عرض (${count})`,
    actionColumn: 'الإجراء',
    duplicationsModalTitle: (firstName: string, lastName: string) => `التكرارات لـ ${firstName} ${lastName}`,
    shiftAllocationsTitle: (count: number) => `تخصيصات الورديات (${count})`,
    excludedAllocationsTitle: (count: number) => `مستثناة من عدد التكرارات (${count})`,
    excludedAllocationsDescription: 'هذه التخصيصات من فعاليات لا تُحتسب في فحوصات التكرار.',
    coreTeamAssignmentsTitle: (count: number) => `تخصيصات الفريق الأساسي (${count})`,
    leadPositionsTitle: (count: number) => `مناصب القائد/نائب القائد (${count})`,
    excludedLeadPositionsTitle: (count: number) => `مناصب القيادة المستثناة (${count})`,
    excludedLeadPositionsDescription: 'هذه المناصب القيادية من فعاليات لا تُحتسب في فحوصات التكرار.',
    positionTypeColumn: 'النوع',
    statusColumn: 'الحالة',
    eventColumn: 'الفعالية',
    areaColumn: 'القسم',
    shiftColumn: 'الوردية',
    dateTimeColumn: 'التاريخ/الوقت',
    noDuplicationsMessage: 'لم يتم العثور على تخصيصات أخرى أو تخصيصات فريق أساسي.',
    closeModalButton: 'إغلاق',
    submittedStatus: 'مقدم',
    approvedStatus: 'معتمد',
    pendingStatus: 'قيد الانتظار',
    acceptedStatus: 'مقبول',
    declinedStatus: 'مرفوض',
    roleColumn: 'الدور',
    streamsColumn: 'المسارات'
}

export const AccessColorMeta: AccessColorMetaProps = {
    title: 'ألوان الوصول',
    description: 'إدارة جميع ألوان الوصول.',
    createButton: 'إنشاء جديد',
    submitButton: 'إنشاء',
    submittingButton: 'جارٍ الإنشاء...',
    errorTitle: 'فشل جلب ألوان الوصول',
    noAnnouncementsMessage: 'لم يتم إنشاء أي ألوان وصول بعد.',
    backButton: 'العودة إلى مركز الإدارة',
    onDeleteTitle: 'حذف لون الوصول',
    onDeleteMessage: 'حذف هذا الوصول سيزيله نهائياً لجميع المستخدمين. هذا الإجراء لا يمكن التراجع عنه.'
}

export const AccessColorFormModalMeta: AccessColorFormModalMetaProps = {
    title: 'إنشاء لون وصول جديد',
    submitButton: 'إنشاء اللون',
    submittingButton: 'جارٍ الإنشاء...',
    cancelButton: 'إلغاء',
    closeButton: 'إغلاق',
    errorMessage: 'فشل إنشاء لون الوصول. يرجى المحاولة مرة أخرى.',
    colorLabel: 'اللون المحدد',
    presetColorLabel: "ألوان مسبقة التعيين",
    updateButton: 'تحديث اللون',
    updatingButton: 'جارٍ تحديث اللون'

}

export const COLOR_PRESETS = [
    '#EF4444', // red
    '#F97316', // orange
    '#FACC15', // yellow
    '#22C55E', // green
    '#3B82F6', // blue
    '#6366F1', // indigo
    '#8B5CF6', // purple
    '#EC4899', // pink
    '#6B7280', // gray
];

export const AVAILABILITY_OPTIONS = [
    "Setup Support (3rd July)",
    "Pre Didar (4th July)",
    "Didar Day (5th July)",
    "Post Didar (6th July)"
] as const


export const VOLUNTEER_FOR_VISIT_MAP = {
    1: "نعم، أرغب في التطوع",
    0: "لا، لست متاحاً في هذا الوقت",
    null: "بدون اختيار" // default case
} as const

export const VOLUNTEER_FOR_VISIT_MAP_INVERSE = {
    "نعم، أرغب في التطوع": 1,
    "لا، لست متاحاً في هذا الوقت": 0,
    "غير محدد": "null",
} as const

export const TrainingSequenceEditMeta: TrainingSequenceEditMetaProps = {
    title: 'تعديل ترتيب التدريب',
    message: 'اسحب التدريبات لتغيير ترتيبها.',
    cancelButton: 'إلغاء',
    submitButton: 'تحديث',
    submittingButton: 'جارٍ التحديث...'
}

export const VolunteerOverviewMeta: VolunteerOverviewMetaProps = {
    title: 'ملخص المتطوعين',
    description: 'نظرة عامة على التركيبة السكانية للمتطوعين',
    errorTitle: 'خطأ أثناء جلب معلومات المتطوعين',
    loadingText: 'جارٍ التحميل'
}

export const TrainingsOverviewMeta: TrainingsOverviewMetaProps = {
    title: 'نظرة عامة على التدريبات',
    description: 'نظرة عامة على تخصيصات التدريب',
    loadingText: 'جارٍ التحميل...',
    errorTitle: 'خطأ في تحميل بيانات التدريب'
}

export const AllocationsOverviewMeta: AllocationsOverviewMetaProps = {
    title: 'ملخص التخصيصات',
    description: 'نظرة عامة على التركيبة السكانية للتخصيصات',
    eventsCardTitle: 'إجمالي الفعاليات',
    areaCardTitle: 'إجمالي الأقسام',
    shiftCardTitle: 'إجمالي الورديات',
    volunteersCardTitle: 'إجمالي المتطوعين',
    allocationsCardTitle: 'إجمالي التخصيصات',
    allocationStatusTitle: 'حالة التخصيص',
    pendingLabel: 'قيد الانتظار',
    acceptedLabel: 'مقبول',
    declinedLabel: 'مرفوض',
    loadingText: 'جارٍ تحميل لوحة المعلومات...',
    errorTitle: 'خطأ في تحميل لوحة المعلومات'
}

export const CoreStreamOverviewMeta: CoreStreamOverviewMetaProps = {
    title: 'نظرة عامة على مسارات الفريق الأساسي',
    description: 'نظرة عامة على تخصيصات مسارات الفريق الأساسي',
    loadingText: 'جارٍ التحميل...',
    errorTitle: 'خطأ في تحميل بيانات الفريق الأساسي',
    noDataMessage: 'لا توجد بيانات مسارات أساسية متاحة.'
}

export const VolunteerStatsTableOverviewMeta: VolunteerStatsTableOverviewMetaProps = {
    title: 'إحصائيات المتطوعين',
    description: 'نظرة عامة على التركيبة السكانية للمتطوعين',
    loadingText: 'جارٍ التحميل...',
    errorTitle: 'خطأ في تحميل البيانات الإحصائية.',
    noDataMessage: 'لا توجد بيانات إحصائية متاحة.'
}

export const DidarAcknowledgementOverviewMeta: DidarAcknowledgementOverviewMetaProps = {
    title: 'نظرة عامة على تأكيد اللقاء',
    description: 'نظرة عامة على تأكيدات اللقاء',
    loadingText: 'جارٍ التحميل...',
    errorTitle: 'خطأ في تحميل بيانات التأكيد.',
    noDataMessage: 'لا توجد بيانات تأكيد متاحة.'
}


export const DashboardMeta: DashboardMetaProps = {
    title: 'لوحة المعلومات',
    description: 'نظرة عامة على المستخدمين والمتطوعين والتخصيصات',
    eventsCardTitle: 'إجمالي الفعاليات',
    areaCardTitle: 'إجمالي الأقسام',
    shiftCardTitle: 'إجمالي الورديات',
    volunteersCardTitle: 'إجمالي المتطوعين',
    allocationsCardTitle: 'إجمالي التخصيصات',
    allocationStatusTitle: 'حالة التخصيص',
    pendingLabel: 'قيد الانتظار',
    acceptedLabel: 'مقبول',
    declinedLabel: 'مرفوض',
    loadingText: 'جارٍ تحميل لوحة المعلومات...',
    errorTitle: 'خطأ في تحميل لوحة المعلومات'
}


export const MangementAnalyticsMeta: ManagementAnalyticsMetaProps = {
    title: 'الإحصائيات',
    description: 'العروض والمرشحات',
    errorTitle: 'خطأ أثناء جلب بيانات المعلومات',
    loadingText: 'جارٍ التحميل...'
}

export const CHART_COLORS = [
    "#2563eb", // blue
    "#16a34a", // green
    "#f59e0b", // amber
    "#dc2626", // red
    "#7c3aed", // violet
    "#0891b2", // cyan
    "#9333ea", // purple
    "#65a30d", // lime
    "#0f766e", // teal
    "#be123c", // rose
    "#ea580c", // orange
    "#1d4ed8", // indigo
    "#15803d", // dark green
    "#854d0e", // brown/gold
    "#9f1239", // dark rose
    "#0369a1", // sky blue
    "#4d7c0f", // olive
    "#6b21a8", // deep purple
    "#b91c1c", // dark red
    "#0f172a", // slate (near-black)
];




export const CHART_HEIGHT_MAP: Record<MaxChartSize, number> = {
    sm: 220,
    md: 260,
    lg: 300,
    xl: 340,
    '2xl': 380,
    '3xl': 420,
    '4xl': 460,
    '5xl': 520,
    '6xl': 580,
    '7xl': 640,
    '8xl': 720,
    '9xl': 800,
    '10xl': 880,
};

export const CHART_WIDTH_CLASSES: Record<MaxChartSize, string> = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl',
    '3xl': 'max-w-3xl',
    '4xl': 'max-w-4xl',
    '5xl': 'max-w-5xl',
    '6xl': 'max-w-6xl',
    '7xl': 'max-w-7xl',
    '8xl': 'max-w-8xl',
    '9xl': 'max-w-9xl',
    '10xl': 'max-w-10xl',
};

export const ANALYTICS_TABS: { key: AnalyticsTab; label: string }[] = [
    { key: "dashboard", label: "لوحة المعلومات" },
    { key: "trainings", label: "نظرة عامة على التدريبات" },
    { key: "volunteers", label: "التركيبة السكانية للمتطوعين" },
    { key: "volunteertable", label: "إحصائيات المتطوعين" },
    { key: "didar", label: "تأكيدات اللقاء" },
    { key: "iff", label: "التركيبة السكانية للعائلات متعددة الأديان" },
    { key: "non-iiuk", label: "التركيبة السكانية للمتطوعين غير IIUK" },
    { key: 'duty_acceptance', label: "إحصائيات قبول المهام" },
    { key: 'check-in', label: 'التركيبة السكانية لتسجيل الحضور' },
];

export const InternationalRegisterationsMeta: InternationalRegisterationsMetaProps = {
    title: "التسجيلات الدولية",
    description: "تم استلام التسجيلات الدولية التالية.",
    errorTitle: "حدث خطأ أثناء جلب التسجيلات الدولية.",
    noDataMessage: "لا توجد تسجيلات متاحة.",
    loadingText: "جارٍ تحميل طلبات التسجيل",
    exportButton: "تصدير CSV",
    lastSignInColumn: "آخر تسجيل دخول",
    neverSignedInText: "لم يسجل الدخول مطلقًا",
}

export const ShiftStatusMap = {
    0: 'مفتوح',
    1: 'قيد المراجعة',
    2: 'معتمد',
    3: 'مرفوض'
}

export const EmailCampaignsMeta: EmailCampaignsMetaProps = {
    title: 'حملات البريد الإلكتروني',
    description: 'إنشاء وإدارة رسائل البريد الإلكتروني الجماعية للمتطوعين',
    createButton: 'إنشاء حملة',
    subjectLabel: 'الموضوع',
    statusLabel: 'الحالة',
    recipientsLabel: 'المستلمون',
    progressLabel: 'التقدم',
    createdLabel: 'تاريخ الإنشاء',
    actionsLabel: 'الإجراءات',
    editButton: 'تعديل',
    deleteButton: 'حذف',
    viewButton: 'عرض',
    statusDraft: 'مسودة',
    statusTestSent: 'تم إرسال الاختبار',
    statusPendingApproval: 'بانتظار الموافقة',
    statusSending: 'جارٍ الإرسال',
    statusCompleted: 'مكتمل',
    statusFailed: 'فاشل',
    pendingApprovalCountLabel: (count) => `${count} بانتظار الموافقة`,
    showPendingApprovalOnlyLabel: 'عرض بانتظار الموافقة فقط',
    showAllCampaignsLabel: 'عرض جميع الحملات',
    noPendingApprovalCampaignsMessage: 'لا توجد حملات تنتظر الموافقة حالياً.',
    noCampaignsMessage: 'لم يتم العثور على حملات بريد إلكتروني. أنشئ حملتك الأولى للبدء.',
    loadingText: 'جارٍ تحميل الحملات...',
    errorTitle: 'خطأ في تحميل الحملات',
    deleteConfirmTitle: 'حذف الحملة',
    deleteConfirmMessage: 'هل أنت متأكد أنك تريد حذف هذه الحملة؟ هذا الإجراء لا يمكن التراجع عنه.',
    cancelButton: 'إلغاء',
    confirmDeleteButton: 'حذف الحملة',
    exportRecipientsButton: 'تصدير المستلمين'
}

export const EmailCampaignFormMeta: EmailCampaignFormMetaProps = {
    createTitle: 'إنشاء حملة بريد إلكتروني',
    editTitle: 'تعديل حملة البريد الإلكتروني',
    subjectLabel: 'موضوع البريد الإلكتروني',
    subjectPlaceholder: 'أدخل موضوع البريد الإلكتروني...',
    bodyLabel: 'نص البريد الإلكتروني',
    bodyPlaceholder: 'اكتب رسالة البريد الإلكتروني...',
    saveDraftButton: 'حفظ المسودة',
    cancelButton: 'إلغاء',
    previewButton: 'معاينة',
    sendTestButton: 'إرسال اختبار',
    sendCampaignButton: 'إرسال الحملة',
    submitForApprovalButton: 'إرسال للموافقة',
    approveCampaignButton: 'الموافقة والإرسال',
    denyCampaignButton: 'رفض وإعادة فتح',
    testEmailsLabel: 'عناوين البريد الإلكتروني للاختبار',
    testEmailsPlaceholder: 'email@example.com',
    testEmailsHint: 'أدخل حتى 10 عناوين بريد إلكتروني لإرسال رسائل اختبار',
    addEmailButton: 'إضافة بريد إلكتروني',
    removeEmailButton: 'حذف',
    confirmSendTitle: 'إرسال حملة البريد الإلكتروني',
    confirmSendMessage: (count) => `أنت على وشك إرسال هذا البريد الإلكتروني إلى ${count} مستلم. هذا الإجراء لا يمكن التراجع عنه. هل أنت متأكد؟`,
    confirmSubmitTitle: 'إرسال الحملة للموافقة',
    confirmSubmitMessage: (count) => `هل تريد إرسال هذه الحملة للموافقة مع ${count} مستلم قابل للإرسال؟ سيتم قفل المحتوى والمستلمين.`,
    confirmApproveTitle: 'الموافقة على الحملة وإرسالها',
    confirmApproveMessage: (count) => `هل تريد الموافقة على هذه الحملة وبدء إرسالها إلى ${count} مستلم؟ هذا الإجراء لا يمكن التراجع عنه.`,
    confirmDenyTitle: 'رفض الحملة',
    confirmDenyMessage: 'هل تريد رفض هذه الحملة وإعادة فتحها للتعديل؟ سيتمكن المنشئ من تحديث المحتوى والمستلمين قبل إرسالها للموافقة مرة أخرى.',
    confirmDenyButton: 'رفض الحملة',
    noTestSentWarning: 'تحذير: لم ترسل أي بريد إلكتروني اختباري بعد. يُنصح بإرسال رسائل اختبار قبل الإرسال لجميع المتطوعين.',
    confirmButton: 'تأكيد الإرسال',
    errorSaving: 'فشل حفظ الحملة',
    errorLoading: 'فشل تحميل الحملة',
    successSaved: 'تم حفظ الحملة بنجاح',
    successTestSent: 'تم إرسال رسالة/رسائل الاختبار بنجاح',
    successSent: 'الحملة قيد الإرسال',
    successSubmitted: 'تم إرسال الحملة للموافقة',
    successDenied: 'تم رفض الحملة وإعادة فتحها للتعديل',
    contentLockedPendingApproval: 'تم إرسال هذه الحملة للموافقة. المحتوى والمستلمون مقفلون حتى يبدأ أحد الموافقين الإرسال.',
    // Targeting criteria
    targetingTitle: 'إضافة مستلمين حسب المجموعة',
    targetingDescription: 'اختر طريقة استهداف لإضافة مجموعة من المستلمين',
    allVolunteersLabel: 'جميع المتطوعين الذين قدموا ملفاتهم',
    targetEventLabel: 'تصفية حسب الفعالية (اختياري)',
    targetAreaLabel: 'تصفية حسب القسم (اختياري)',
    targetShiftLabel: 'تصفية حسب الوردية (اختياري)',
    targetDutyLabel: 'تصفية حسب نوع المهمة (اختياري)',
    selectEventPlaceholder: 'جميع الفعاليات (جميع المتطوعين)',
    selectAreaPlaceholder: 'جميع الأقسام في هذه الفعالية',
    selectShiftPlaceholder: 'جميع الورديات في هذا القسم',
    selectDutyPlaceholder: 'جميع أنواع المهام',
    loadingEvents: 'جارٍ تحميل الفعاليات...',
    loadingAreas: 'جارٍ تحميل الأقسام...',
    loadingShifts: 'جارٍ تحميل الورديات...',
    loadingDuties: 'جارٍ تحميل المهام...',
    includeLeadsLabel: 'تضمين القادة أيضاً:',
    includeEventLeadsLabel: 'قادة الفعاليات',
    includeAreaLeadsLabel: 'قادة/نواب الأقسام',
    includeShiftLeadsLabel: 'قادة/نواب الورديات',
    // Volunteer types and volunteer filters for "all volunteers" option
    volunteerTypesLabel: 'أنواع المتطوعين',
    volunteerTypeIiukUkIreland: 'مسجل IIUK (محلي - أوروبا)',
    volunteerTypeIiukEurope: 'مسجل IIUK (دولي)',
    volunteerTypeNonIiuk: 'مجتمع المتطوعين (غير IIUK)',
    volunteerForVisitLabel: 'التطوع خلال اللقاء',
    volunteerForVisitYes: 'التطوع خلال اللقاء (أعلنوا توفرهم)',
    volunteerForVisitNo: 'لا - غير متاح للتطوع',
    volunteerForVisitBoth: 'كلاهما (جميع الردود)',
    // Recipient management
    recipientManagementTitle: 'إدارة المستلمين',
    recipientManagementDescription: 'أضف مستلمين بشكل فردي أو جماعي. يتم حذف التكرارات تلقائياً.',
    recipientSourceHistoryTitle: 'سجل مصدر المستلمين',
    recipientSourceHistoryDescription: 'راجع كيف تمت إضافة المستلمين قبل الموافقة على هذه الحملة.',
    recipientSourceNoHistory: 'لم يتم تسجيل سجل مصدر لهذه الحملة. ربما تم إنشاؤها قبل إضافة التتبع.',
    recipientSourceAddedLabel: 'تمت الإضافة',
    recipientSourceSelectedLabel: 'تم الاختيار',
    recipientSourceDuplicatesLabel: 'التكرارات المتخطاة',
    recipientSourceWithoutEmailLabel: 'بلا بريد إلكتروني',
    recipientSourceTotalAfterLabel: 'الإجمالي بعد التغيير',
    recipientSourceAddedByLabel: 'بواسطة',
    recipientSourceShowButton: 'إظهار السجل',
    recipientSourceHideButton: 'إخفاء السجل',
    recipientListTitle: 'قائمة المستلمين',
    noRecipientsMessage: 'لم يتم إضافة مستلمين بعد. استخدم الأزرار أعلاه لإضافة مستلمين.',
    addGroupButton: 'إضافة مجموعة',
    addIndividualButton: 'إضافة فرد',
    clearAllButton: 'مسح الكل',
    recipientCountLabel: (count) => `${count} مستلم`,
    removeRecipientButton: 'حذف',
    searchVolunteersPlaceholder: 'البحث عن متطوعين حسب الاسم...',
    addSelectedButton: 'إضافة المحددين',
    groupAddedMessage: (added, total) => `تمت إضافة ${added} مستلم جديد. الإجمالي: ${total}`,
    individualAddedMessage: (added, total) => `تمت إضافة ${added} مستلم. الإجمالي: ${total}`,
    clearConfirmTitle: 'مسح جميع المستلمين',
    clearConfirmMessage: 'هل أنت متأكد أنك تريد حذف جميع المستلمين من هذه الحملة؟',
    confirmClearButton: 'مسح الكل',
    // Email suggestions
    emailSuggestionsTitle: 'تعيين عنوان البريد الإلكتروني',
    emailSuggestionsDescription: 'اختر عنوان بريد إلكتروني لـ',
    customEmailLabel: 'أدخل بريداً إلكترونياً مخصصاً',
    saveButton: 'حفظ',
    noEmailSuggestions: 'لا توجد اقتراحات متاحة. يرجى إدخال بريد إلكتروني يدوياً.',
    // Retry failed
    retryFailedButton: 'إعادة محاولة الفاشلة',
    retryFailedConfirmTitle: 'إعادة محاولة رسائل البريد الإلكتروني الفاشلة',
    retryFailedConfirmMessage: (count: number) => `أنت على وشك إعادة المحاولة لـ ${count} مستلم فاشل. هل تريد المتابعة؟`,
    confirmRetryButton: 'إعادة المحاولة',
    successRetry: (count: number) => `جارٍ إعادة المحاولة لـ ${count} بريد إلكتروني فاشل...`
}

export const EmailCampaignPreviewMeta: EmailCampaignPreviewMetaProps = {
    title: 'معاينة البريد الإلكتروني',
    closeButton: 'إغلاق',
    backButton: 'العودة إلى التحرير',
    testWarningTitle: 'إشعار بريد إلكتروني اختباري',
    testWarningMessage: 'يظهر هذا الشريط فقط في رسائل البريد الإلكتروني الاختبارية. لن يتم تضمينه في الحملة الفعلية.'
}

export const ShiftMoveModalMeta: ShiftMoveModalMetaProps = {
    title: "نقل المتطوع",
    submitButton: "نقل",
    submittingButton: "جارٍ النقل...",
    closeButton: "إلغاء",
    eventLabel: "الفعالية",
    areaLabel: "القسم",
    shiftLabel: "الوردية",
    eventPlaceHolder: "اختر الفعالية",
    areaPlaceHolder: "اختر القسم",
    shiftPlaceHolder: "اختر الوردية"
}


export const VolunteerUploadDocumentFormMeta: VolunteerUploadDocumentFormMetaProps = {
    title: "رفع مستند",
    cancelButton: "إلغاء",
    submitButton: "رفع",
    submittingButton: "جارٍ الرفع...",
    documentTypeLabel: "نوع المستند"
}

export const UPLOAD_DOCUMENT_TYPES = ["DBS (قياسي)", "DBS (متقدم)", "إسعافات أولية", "شهادة طبية"]

export const AllocationStatusPageMeta: AllocationStatusPageMetaProps = {
    title: 'إدارة قبول المهام',
    description: 'عرض وإدارة حالات قبول مهام المتطوعين، والتصفية حسب معايير مختلفة، وإعادة تخصيص المتطوعين عند الحاجة.',
    backLink: '← العودة إلى مركز الإدارة',
    // Status badges
    pendingLabel: 'قيد الانتظار',
    acceptedLabel: 'مقبول',
    declinedLabel: 'مرفوض',
    allLabel: 'الكل',
    // Filter labels
    filtersTitle: 'المرشحات',
    statusFilterLabel: 'الحالة',
    eventFilterLabel: 'الفعالية',
    areaFilterLabel: 'القسم',
    shiftFilterLabel: 'الوردية',
    volunteerSearchLabel: 'البحث عن متطوع',
    volunteerSearchPlaceholder: 'البحث حسب الاسم أو البريد الإلكتروني أو المعرف...',
    declineReasonFilterLabel: 'سبب الرفض',
    dateRangeLabel: 'نطاق تاريخ الرد',
    dateFromLabel: 'من',
    dateToLabel: 'إلى',
    offeredAsTknLabel: 'مقدم كـ TKN',
    // Volunteer count filters
    volunteerCountsTitle: 'التصفية حسب عدد ردود المتطوعين',
    volunteerCountsEventsLabel: 'عدد الردود في الفعاليات:',
    volunteerCountsEventsAllLabel: 'جميع الفعاليات',
    minPendingCountLabel: 'الحد الأدنى قيد الانتظار',
    maxPendingCountLabel: 'الحد الأقصى قيد الانتظار',
    minAcceptedCountLabel: 'الحد الأدنى مقبول',
    maxAcceptedCountLabel: 'الحد الأقصى مقبول',
    minDeclinedCountLabel: 'الحد الأدنى مرفوض',
    maxDeclinedCountLabel: 'الحد الأقصى مرفوض',
    // Filter placeholders
    selectEventPlaceholder: 'جميع الفعاليات',
    selectAreaPlaceholder: 'جميع الأقسام',
    selectShiftPlaceholder: 'جميع الورديات',
    selectDeclineReasonPlaceholder: 'جميع الأسباب',
    // Actions
    searchButton: 'بحث',
    clearFiltersButton: 'مسح المرشحات',
    exportCsvButton: 'تصدير CSV',
    exportingButton: 'جارٍ التصدير...',
    // Table
    tableVolunteerColumn: 'المتطوع',
    tableEventColumn: 'الفعالية',
    tableAreaColumn: 'القسم',
    tableShiftColumn: 'الوردية',
    tableStatusColumn: 'الحالة',
    tableTknColumn: 'TKN',
    tableDeclineReasonColumn: 'سبب الرفض',
    tableResponseDateColumn: 'تاريخ الرد',
    tableActionsColumn: 'الإجراءات',
    // Bulk actions
    bulkActionsTitle: 'إجراءات جماعية',
    selectedCountLabel: (count) => `${count} محدد`,
    changeStatusButton: 'تغيير الحالة',
    reAllocateButton: 'إعادة التخصيص',
    setToPendingButton: 'تعيين كقيد الانتظار',
    setToAcceptedButton: 'تعيين كمقبول',
    setToDeclinedButton: 'تعيين كمرفوض',
    // Messages
    noResultsMessage: 'لم يتم العثور على تخصيصات مطابقة لمعاييرك.',
    loadingMessage: 'جارٍ تحميل التخصيصات...',
    errorMessage: 'حدث خطأ أثناء تحميل التخصيصات.',
    bulkUpdateSuccessMessage: (count) => `تم تحديث ${count} تخصيص بنجاح.`,
    bulkUpdateErrorMessage: 'فشل تحديث التخصيصات. يرجى المحاولة مرة أخرى.',
    // Re-allocate modal
    reAllocateTitle: 'إعادة تخصيص المتطوع(ين)',
    reAllocateDescription: 'اختر وردية جديدة لتخصيص المتطوع(ين) المحددين إليها. سيؤدي هذا إلى إنشاء تخصيص جديد دون التأثير على التخصيص الأصلي.',
    reAllocateEventLabel: 'الفعالية',
    reAllocateAreaLabel: 'القسم',
    reAllocateShiftLabel: 'الوردية',
    reAllocateWarning: 'ملاحظة: سيبقى التخصيص الأصلي دون تغيير. سيؤدي هذا إلى إنشاء تخصيص جديد بحالة قيد الانتظار.',
    reAllocateDuplicateWarning: 'تحذير: متطوع واحد أو أكثر لديهم تخصيص بالفعل لهذه الوردية.',
    reAllocateSubmitButton: 'إنشاء تخصيص جديد',
    reAllocatingButton: 'جارٍ الإنشاء...',
    reAllocateCancelButton: 'إلغاء',
    reAllocateSuccessMessage: (count) => `تم إنشاء ${count} تخصيص جديد بنجاح.`,
    reAllocateErrorMessage: 'فشل إنشاء التخصيصات الجديدة. يرجى المحاولة مرة أخرى.',
    // Pagination
    previousButton: 'السابق',
    nextButton: 'التالي',
    pageLabel: 'صفحة',
    itemsPerPageLabel: 'عناصر لكل صفحة',
    totalItemsLabel: (count) => `${count} عنصر إجمالي`,
    // Decline reasons (copied from Home for consistency)
    declineReasons: [
        'التوقيت غير مناسب (قد يُعرض عليك وردية أخرى حسب التوفر)',
        'لا أرغب في هذه المهمة بالتحديد (قد يُعرض عليك وردية أخرى حسب التوفر)',
        'غير قادر على الالتزام في هذا الوقت (سأتوجه إلى VRC في اليوم المعني)',
        'لأسباب شخصية أخرى لا أرغب في المتابعة'
    ],
    startTimeLabel: 'وقت البداية',
    endTimeLabel: 'وقت النهاية'
}

export const ALLOCATION_STATUS_OPTIONS = ["Accepted", "Declined", "Pending"]

export const CheckInPageMeta: CheckInPageMetaProps = {
    title: 'تسجيل حضور المتطوع',
    description: 'امسح شارات المتطوعين أو ابحث حسب الاسم لتسجيل حضورهم في المهام المخصصة لهم.',
    backToAdmin: 'العودة إلى الإدارة',
    // Mode toggle
    scanModeLabel: 'مسح الشارة',
    searchModeLabel: 'بحث',
    // Scanner input
    scannerPlaceholder: 'امسح الشارة أو أدخل الباركود...',
    scannerLabel: 'ماسح الشارة',
    scannerHint: 'ضع باركود الشارة أمام الماسح',
    // Search input
    searchPlaceholder: 'البحث حسب الاسم أو البريد الإلكتروني أو المعرف...',
    searchLabel: 'البحث عن متطوع',
    searchHint: 'أدخل حرفين على الأقل للبحث',
    searchButton: 'بحث',
    searchingText: 'جارٍ البحث...',
    searchResultsTitle: 'نتائج البحث',
    noSearchResultsMessage: 'لم يتم العثور على متطوعين مطابقين لبحثك.',
    selectVolunteerButton: 'اختيار',
    // Event filter
    eventFilterLabel: 'اختيار الفعالية',
    selectEventPrompt: 'يرجى اختيار فعالية',
    // Volunteer display
    volunteerNotFoundMessage: 'لم يتم العثور على المتطوع. يرجى المسح مرة أخرى.',
    loadingMessage: 'جارٍ البحث عن المتطوع...',
    errorMessage: 'حدث خطأ. يرجى المحاولة مرة أخرى.',
    scanToBeginMessage: 'امسح شارة متطوع لبدء تسجيل الحضور',
    searchToBeginMessage: 'ابحث عن متطوع حسب الاسم لبدء تسجيل الحضور',
    // Volunteer card
    volunteerCardTitle: 'تفاصيل المتطوع',
    emailLabel: 'البريد الإلكتروني',
    phoneLabel: 'الهاتف',
    countryLabel: 'الدولة',
    jamatkhanaLabel: 'جماعت خانة',
    // Allocations
    allocationsTitle: 'تخصيصات المهام',
    noAllocationsMessage: 'لم يتم العثور على تخصيصات مهام لهذا المتطوع.',
    noAllocationsForEventMessage: 'لا توجد تخصيصات للفعالية المحددة.',
    eventColumn: 'الفعالية',
    areaColumn: 'القسم',
    shiftColumn: 'الوردية',
    timeColumn: 'الوقت',
    statusColumn: 'القبول',
    actionColumn: 'تسجيل الحضور',
    // Check-in status
    checkedInLabel: 'تم تسجيل الحضور',
    notCheckedInLabel: 'لم يتم تسجيل الحضور',
    checkedInAtLabel: (time) => `تم تسجيل الحضور في ${time}`,
    checkedInByLabel: (name) => `بواسطة ${name}`,
    // Buttons
    checkInButton: 'تسجيل الحضور',
    undoCheckInButton: 'إلغاء تسجيل الحضور',
    checkingInButton: 'جارٍ التسجيل...',
    deallocateDutyButton: 'إزالة التخصيص',
    deallocatingDutyButton: 'جارٍ الإزالة...',
    scanAnotherButton: 'المسح التالي',
    allocateDutyButton: 'تخصيص مهمة',
    // Messages
    checkInSuccessMessage: 'تم تسجيل الحضور بنجاح!',
    undoCheckInSuccessMessage: 'تم إلغاء تسجيل الحضور.',
    deallocateDutyConfirmMessage: (dutyName) => `إزالة ${dutyName} من هذا المتطوع؟ لا يمكن التراجع عن ذلك.`,
    deallocateDutySuccessMessage: 'تمت إزالة تخصيص المهمة بنجاح.',
    deallocateDutyErrorMessage: 'فشلت إزالة تخصيص المهمة. يرجى المحاولة مرة أخرى.',
    checkInErrorMessage: 'فشل تسجيل الحضور. يرجى المحاولة مرة أخرى.',
    // Allocation status badges
    pendingStatusLabel: 'قيد الانتظار',
    acceptedStatusLabel: 'مقبول',
    declinedStatusLabel: 'مرفوض',
    // Camera scanning
    cameraScanButton: 'استخدام الكاميرا',
    cameraScannerTitle: 'مسح الشارة بالكاميرا',
    cameraScannerHint: 'ضع باركود الشارة في مجال رؤية الكاميرا',
    cameraPermissionDenied: 'تم رفض إذن الكاميرا. يرجى السماح بالوصول إلى الكاميرا لاستخدام هذه الميزة.',
    cameraNotSupported: 'المسح بالكاميرا غير مدعوم على هذا الجهاز.',
    closeCameraButton: 'إغلاق',
    // Shift View mode
    shiftViewModeLabel: 'عرض الوردية',
    shiftViewAreaLabel: 'القسم',
    shiftViewShiftLabel: 'الوردية',
    shiftViewSelectAreaPrompt: 'اختر قسماً',
    shiftViewSelectShiftPrompt: 'اختر وردية',
    shiftViewNoAreasMessage: 'لم يتم العثور على أقسام للفعاليات المحددة.',
    shiftViewNoShiftsMessage: 'لم يتم العثور على ورديات للقسم المحدد.',
    shiftViewLoadingVolunteers: 'جارٍ تحميل المتطوعين...',
    shiftViewNoVolunteersMessage: 'لم يتم تخصيص متطوعين لهذه الوردية.',
    shiftViewVolunteerCount: (checked, total) => `${checked}/${total} حاضرون`,
    shiftViewNameColumn: 'الاسم',
    shiftViewPhoneColumn: 'الهاتف',
    shiftViewTimeColumn: 'النطاق الزمني',
    shiftViewStatusColumn: 'الحالة',
    shiftViewActionColumn: 'الإجراء',
    // Create volunteer
    createVolunteerButton: "لم تجده؟ أنشئ هنا"
}

export const DutyStatusOverviewMeta: DutyStatusOverviewMetaProps = {
    title: "إحصائيات قبول المهام",
    description: "يعرض الجدول التالي تفصيل حالة قبول المهام للورديات المنشورة.",
    errorTitle: "فشل جلب الإحصائيات.",
    loadingText: "جارٍ التحميل...",
    eventSelectionLabel: "اختر الفعاليات للتحليل"
}

export const QuickAllocateModalMeta: QuickAllocateModalMetaProps = {
    title: 'تخصيص سريع للمهمة',
    subtitle: (volunteerName) => `تخصيص مهمة لـ ${volunteerName}`,
    // Search
    searchPlaceholder: 'البحث في الورديات أو الأقسام...',
    // Sort options
    sortLabel: 'ترتيب حسب',
    sortByUrgency: 'الأهمية',
    sortByStartTime: 'وقت البداية',
    sortByAlphabetical: 'أبجدي',
    // Stats labels
    requiredLabel: 'مطلوب',
    acceptedLabel: 'مقبول',
    checkedInLabel: 'تم تسجيل الحضور',
    // Shift display
    noShiftsMessage: 'لم يتم العثور على ورديات متاحة لهذه الفعالية.',
    loadingShiftsMessage: 'جارٍ تحميل الورديات...',
    viewOtherShiftsButton: (count) => `عرض الورديات الأخرى (${count})`,
    hideOtherShiftsButton: 'إخفاء الورديات الأخرى',
    // Conflict labels
    alreadyAllocatedLabel: 'مخصص بالفعل',
    timeConflictLabel: 'تعارض زمني',
    // Buttons
    allocateButton: 'تخصيص',
    allocatingButton: 'جارٍ التخصيص...',
    cancelButton: 'إلغاء',
    closeButton: 'إغلاق',
    // Messages
    allocationSuccessMessage: 'تم تخصيص المهمة بنجاح!',
    allocationErrorMessage: 'فشل تخصيص المهمة. يرجى المحاولة مرة أخرى.'
}

export const LiveOperationsMeta: LiveOperationsMetaProps = {
    title: "العمليات الحية للفعالية",
    description: 'مراقبة حضور المتطوعين في الوقت الفعلي وتغطية الورديات والمقاييس التشغيلية الحرجة.',
    errorTitle: 'خطأ',
    areaCheckBoxTitle: 'اختيار الأقسام',
    areaCheckBoxLabel: 'اختر الأقسام من الورديات التي تريد عرضها',
    shiftsMeta: { title: 'الورديات المتاحة', description: 'الورديات التالية تحتاج إلى دعم متطوعين' }
}

export const LIVE_OPERATIONS_TABS: { key: LiveStatusTab, header: string }[] = [
    { key: "checkin-stats", header: "تسجيلات الحضور" },
    { key: "shifts", header: "الورديات العاجلة" },
]

export const LoginFormMeta: LoginFormMetaProps = {
    title: 'تسجيل دخول غير IIUK',
    emailLabel: 'البريد الإلكتروني',
    emailPlaceholder: 'name@company.com',
    passwordLabel: 'كلمة المرور',
    passwordPlaceholder: '••••••••',
    forgotPassword: 'نسيت كلمة المرور؟',
    loginButton: 'تسجيل الدخول',
    createAccount: 'إنشاء حساب',
    errorLabel: 'خطأ:',
    sending: 'جارٍ الإرسال...',
    resendVerification: 'إعادة إرسال بريد التحقق',
    travelInfo: 'إذا كان لديك ترتيبات سفر مسبقة وترغب في التطوع، يرجى تسجيل اهتمامك. التطوع يعتمد على الترتيبات الشخصية ويجب ترتيب جميع متطلبات السفر والإقامة والتأشيرة والأمور ذات الصلة بشكل مستقل.'
}

export const ForgetPasswordMeta: ForgetPasswordMetaProps = {
    back: 'رجوع',
    errorLabel: 'خطأ:',
    successLabel: 'نجاح!',
    successMessage: 'يرجى التحقق من صندوق البريد الوارد (ومجلد البريد العشوائي) للحصول على رابط إعادة تعيين كلمة المرور.',
    title: 'نسيت كلمة المرور',
    emailLabel: 'البريد الإلكتروني',
    emailPlaceholder: 'you@example.com',
    sendResetLink: 'إرسال رابط إعادة التعيين'
}

export const ResetPasswordMeta: ResetPasswordMetaProps = {
    errorLabel: 'خطأ:',
    successLabel: 'نجاح!',
    title: 'إعادة تعيين كلمة المرور',
    passwordLabel: 'كلمة المرور',
    passwordPlaceholder: 'كلمة المرور الجديدة',
    confirmPasswordLabel: 'تأكيد كلمة المرور',
    confirmPasswordPlaceholder: 'تأكيد كلمة المرور الجديدة',
    resetting: 'جارٍ إعادة التعيين...',
    resetButton: 'إعادة تعيين كلمة المرور',
    invalidLinkError: 'رابط إعادة تعيين كلمة المرور غير صالح أو منتهي الصلاحية.',
    passwordsDoNotMatch: 'كلمات المرور غير متطابقة.',
    missingTokenError: 'الرمز المميز أو البريد الإلكتروني مفقود. يرجى استخدام الرابط من بريدك الإلكتروني.'
}

export const SignupMeta: SignupMetaProps = {
    checkEmailTitle: 'تحقق من بريدك الإلكتروني',
    checkEmailMessage: 'لقد أرسلنا رابط تحقق إلى عنوان بريدك الإلكتروني. يرجى النقر على الرابط لتأكيد حسابك.',
    checkEmailHint: 'لم تستلم البريد الإلكتروني؟ تحقق من مجلد البريد العشوائي. تنتهي صلاحية رابط التحقق بعد 60 دقيقة.',
    travelInfo: 'إذا كان لديك ترتيبات سفر مسبقة وترغب في التطوع، يرجى تسجيل اهتمامك. التطوع يعتمد على الترتيبات الشخصية ويجب ترتيب جميع متطلبات السفر والإقامة والتأشيرة والأمور ذات الصلة بشكل مستقل.',
    accountInfoTitle: 'معلومات الحساب',
    emailPlaceholder: 'عنوان البريد الإلكتروني',
    passwordPlaceholder: 'كلمة المرور',
    rePasswordPlaceholder: 'تكرار كلمة المرور',
    volunteerInfoTitle: 'معلومات المتطوع',
    firstNamePlaceholder: 'الاسم الأول',
    lastNamePlaceholder: 'اسم العائلة',
    selectGender: 'اختر الجنس',
    male: 'ذكر',
    female: 'أنثى',
    preferNotToSay: 'أفضل عدم الإفصاح',
    countryCodePlaceholder: 'رمز الدولة مثلاً: +966',
    phonePlaceholder: 'رقم الهاتف',
    countryPlaceholder: 'الدولة',
    jamatkhanaPlaceholder: 'جماعت خانة',
    familyOriginLabel: 'الأصل العائلي',
    selectOrigin: 'اختر الأصل',
    additionalDetailsTitle: 'تفاصيل إضافية',
    ismaili: 'إسماعيلي',
    interFaithFamily: 'عائلة متعددة الأديان',
    languagesLabel: 'اللغات',
    supportNeedsPlaceholder: 'احتياجات دعم إضافية…',
    registerButton: 'تسجيل',
    registering: 'جارٍ التسجيل…',
    passwordsDoNotMatch: 'كلمات المرور غير متطابقة.',
    faithStatusRequired: 'يرجى اختيار إسماعيلي أو عائلة متعددة الأديان.',
    invalidDob: 'يرجى إدخال تاريخ ميلاد صالح.'
}

export const VerifyEmailMeta: VerifyEmailMetaProps = {
    title: 'التحقق من البريد الإلكتروني',
    verifying: 'جارٍ التحقق من بريدك الإلكتروني...',
    successTitle: 'تم التحقق من البريد الإلكتروني بنجاح!',
    successMessage: 'شكراً لتسجيلك كمتطوع لزيارة المملكة المتحدة.',
    reviewMessage: 'طلب تسجيلك التطوعي قيد المراجعة.',
    approvalNotice: 'ستتلقى بريداً إلكترونياً إعلامياً بمجرد اعتماد تسجيلك من قبل فريقنا.',
    travelInfo: 'إذا كان لديك ترتيبات سفر مسبقة وترغب في التطوع، يرجى تسجيل اهتمامك. التطوع يعتمد على الترتيبات الشخصية ويجب ترتيب جميع متطلبات السفر والإقامة والتأشيرة والأمور ذات الصلة بشكل مستقل.',
    backToLogin: 'العودة إلى تسجيل الدخول',
    backToSignup: 'العودة إلى التسجيل',
    sending: 'جارٍ الإرسال...',
    resendVerification: 'إعادة إرسال بريد التحقق',
    invalidLinkError: 'رابط التحقق غير صالح. يرجى التحقق من الرابط في بريدك الإلكتروني.'
}

export const HouseholdSelectionMeta: HouseholdSelectionMetaProps = {
    errorTitle: 'خطأ',
    returnToLogin: 'العودة إلى تسجيل الدخول',
    title: 'اختيار فرد من الأسرة',
    description: 'يرجى اختيار فرد الأسرة الذي ترغب في استخدام المنصة كحسابه.',
    youBadge: 'أنت',
    cancel: 'إلغاء',
    loadError: 'فشل تحميل أفراد الأسرة. يرجى تسجيل الدخول مرة أخرى.'
}

export const CheckInLoginFormMeta: CheckInLoginFormMetaProps = {
    errorLabel: 'خطأ:',
    title: 'تسجيل الدخول لتسجيل الحضور',
    usernameLabel: 'اسم المستخدم',
    usernamePlaceholder: 'أدخل اسم المستخدم',
    passwordLabel: 'كلمة المرور',
    passwordPlaceholder: 'أدخل كلمة المرور',
    loginButton: 'تسجيل الدخول'
}


export const ApprovedCountries = [
    'Austria',
    'Germany',
    'Italy',
    'Poland',
    'Denmark',
    'Finland',
    'Netherlands',
    'Norway',
    'Sweden',
    'Bulgaria',
    'Czech Republic',
    'Estonia',
    'Greece',
    'Hungary',
    'Latvia',
    'Lithuania',
    'Malta',
    'North Macedonia',
    'Romania',
    'Slovakia',
    'Slovenia',
    'North Cyprus',
    'Turkey',
    //'Türkiye',
]


export const EU_JAMAT_KHANA_OPTIONS = [
    'amsterdam',
    'bad salzuflen',
    'berlin',
    'bologna',
    'bosel',
    'bulgaria',
    'cologne',
    'copenhagen',
    'czech',
    'dresden',
    'eindhoven',
    'erfurt',
    'essen',
    'estonia',
    'frankfurt',
    'gothenburg',
    'graz',
    'greece',
    'hamburg',
    'helsinki',
    'hungary',
    'kassel',
    'krakow',
    'latvia',
    'leipzig',
    'linz',
    'lithuania',
    'ljungby',
    'malmo',
    'malta',
    'munich',
    'nicosia',
    'north macedonia',
    'orebro',
    'oslo',
    'romania',
    'rome',
    'rotterdam',
    'rzeszow',
    'slovakia',
    'slovenia',
    'stockholm',
    'stuttgart',
    'szczecin',
    'turkey',
    'umea',
    'vanersborg',
    'vienna',
    'warsaw',
    'wuppertal',
    'zevenaar',
];

export const GuidelineFormModalMeta: GuidelineFormModalMetaProps = {
    title: 'إنشاء إرشاد',
    nameLabel: 'الاسم',
    namePlaceholder: 'الاسم...',
    descriptionLabel: 'الوصف',
    descriptionPlaceholder: 'الوصف...',
    audienceLabel: 'من يمكنه رؤية هذا الإرشاد؟',
    audienceAllOption: 'تحديد الكل',
    audienceServiceRecordOption: 'تحديد مواقع المتطوعين',
    addModuleButton: 'إضافة محتوى',
    noModulesMessage: 'لا يوجد محتوى متاح',
    uploadButton: 'حفظ الإرشاد',
    uploadingLabel: 'جارٍ الحفظ...',
    cancelButton: 'إلغاء',
    submitButton: 'إرسال',
    submittingButton: 'جارٍ الإرسال...'
}

export const AdminGuidelinesMeta: AdminGuidelinesMetaProps = {
    title: 'الإرشادات',
    description: 'إدارة الإرشادات المرجعية للمتطوعين',
    errorTitle: 'خطأ',
    noGuidelinesMessage: 'لا توجد إرشادات بعد',
    loadingText: 'جارٍ التحميل...'
}

export const VolunteerGuidelinesMeta: VolunteerGuidelinesMetaProps = {
    title: 'الإرشادات',
    errorTitle: 'خطأ',
    noGuidelinesMessage: 'لا توجد إرشادات متاحة',
    documentsLabel: 'مستند'
}

export const GuidelineDetailsMeta: GuidelineDetailsMetaProps = {
    backButtonLabel: 'العودة إلى الإرشادات',
    errorTitle: 'خطأ',
    notFoundMessage: 'الإرشاد غير موجود'
}

export const DirectorVolunteerMeta: DirectorVolunteerMetaProps = {
    title: "متطوعو جامات خانتك",
    description: "عرض متطوعي جامات خانتك"
}



